"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconPencilWrite = exports.IconPencilSmall = exports.IconPaymentsLogo = exports.IconPayments = exports.IconPaperclip = exports.IconOpenEnvelope = exports.IconOffers = exports.IconNotepad = exports.IconMore = exports.IconMobilePhone = exports.IconMobilePhoneView = exports.IconMobilePhoneQuestionMark = exports.IconMobilePhoneClose = exports.IconMobilePhoneCheck = exports.IconMinus = exports.IconMention = exports.IconMedal = exports.IconMarkUnread = exports.IconManager = exports.IconLogout = exports.IconLock = exports.IconLocationUser = exports.IconLocationUserCircle = exports.IconLocationPin = exports.IconLocationPinLine = exports.IconLocationCircle = exports.IconLocationAdmin = exports.IconList = exports.IconLightBulb = exports.IconLayout = exports.IconIntercom = exports.IconInfo = exports.IconInbox = exports.IconHamburger = exports.IconGraphPie = exports.IconGraphBar = exports.IconGoogleMessage = exports.IconGlobe = exports.IconGiftOpen = exports.IconGear = exports.IconFormatting = exports.IconFilter = exports.IconFile = exports.IconFileZip = exports.IconFileVideo = exports.IconFileText = exports.IconFilePdf = exports.IconFileDollar = exports.IconFileCsv = exports.IconFileCopy = exports.IconFileCoding = exports.IconFileBlank = exports.IconFileAudio = exports.IconFeedback = exports.IconFacebookMessenger = exports.IconFaceMeh = exports.IconFaceHappy = exports.IconFaceAngry = exports.IconEye = exports.IconEyeSlashed = exports.IconExpand = exports.IconEnvelope = exports.IconEnvelopeLine = exports.IconDustpan = exports.IconDownload = exports.IconDownloadSquare = exports.IconDownloadSquareSolid = exports.IconDesktop = exports.IconCustomerJourney = exports.IconCrown = exports.IconCreditCard = exports.IconCopy = exports.IconContributor = exports.IconClick = exports.IconChevron = exports.IconCheckboxBlankReadonly = exports.IconCheck = exports.IconCheckCircle = exports.IconChatBubbles = exports.IconChatBubble = exports.IconChatBubbleLine = exports.IconChatBubbleEmpty = exports.IconCalendar = exports.IconCalendarClock = exports.IconCalendarAdd = exports.IconBuilding = exports.IconBuildingCircle = exports.IconBrackets = exports.IconBookmark = exports.IconBlock = exports.IconArrow = exports.IconArchive = exports.IconAlertTriangle = exports.IconAlertReviewInvite = exports.IconAlertNps = exports.IconAlertEmailBounce = exports.IconAlertCircle = exports.IconAlertCircleSolid = exports.IconAlertBrokenIntegration = exports.IconAlertBell = void 0;
exports.IconX = exports.IconXCircle = exports.IconWindowChecked = exports.IconWindowArrow = exports.IconWebchat = exports.IconWand = exports.IconVideo = exports.IconVariables = exports.IconUser = exports.IconUserSolid = exports.IconUserPlus = exports.IconUserMagnify = exports.IconUserGroup = exports.IconUserChat = exports.IconTrendingUp = exports.IconTrendingDown = exports.IconTrash = exports.IconTeamchat = exports.IconTag = exports.IconTable = exports.IconStore = exports.IconStar = exports.IconStarLine = exports.IconStarCrossed = exports.IconStarAdd = exports.IconSkyhookLogo = exports.IconShieldX = exports.IconShieldChecked = exports.IconShare = exports.IconSend = exports.IconSearch = exports.IconSalesforce = exports.IconRefund = exports.IconReceipt = exports.IconQuestion = exports.IconQuestionSolid = exports.IconPossibleIntegrations = exports.IconPodiumIcon = exports.IconPlus = exports.IconPlusCircle = exports.IconPlusCircleSolid = exports.IconPlay = exports.IconPictureLayer = exports.IconPictureLayerSolid = exports.IconPending = exports.IconPencil = void 0;

var _react = _interopRequireDefault(require("react"));

var _withSize = _interopRequireDefault(require("./withSize"));

var _withDirection = _interopRequireDefault(require("./withDirection"));

/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
 * This file is autogenerated from bin/build-icons.js
 *
 * Import and export statements must be in this format for the inline-react-svg babel plugin
 */
var AlertBell = function AlertBell(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M13.333 19.333c.369 0 .667.299.667.667a2 2 0 0 1-4 0 .667.667 0 0 1 1.326-.098l.007.098a.667.667 0 0 0 1.327.098l.007-.098c0-.368.298-.667.666-.667zM12 3.333c.335 0 .612.247.66.569l.007.098v1.093c2.976.376 5.221 3.245 5.329 6.651L18 12c0 1.742.235 3.048.617 3.978.187.456.357.714.454.82l.099.098a.672.672 0 0 1 .005.007l-.07-.072a.669.669 0 0 1 .21.346l.004.02a.645.645 0 0 1 .014.136v.029a.669.669 0 0 1-.004.049l.004-.078a.67.67 0 0 1-.164.438l-.017.02a.67.67 0 0 1-.387.202l-.027.003a.67.67 0 0 1-.044.003l-.027.001H5.298a.67.67 0 0 1-.035-.004l.07.004a.67.67 0 0 1-.433-.16l-.004-.003-.07-.07-.025-.032a.668.668 0 0 1-.033-.048l.059.08a.67.67 0 0 1-.16-.415v-.044a.67.67 0 0 1 .005-.056l-.005.081a.67.67 0 0 1 .23-.503c.09-.077.277-.335.487-.844.354-.86.582-2.05.613-3.617L6 12c0-3.517 2.283-6.521 5.333-6.907V4c0-.368.299-.667.667-.667zm0 3.051c-2.51 0-4.553 2.397-4.662 5.367l-.005.25c0 1.918-.265 3.397-.716 4.493l-.076.172h10.92a6.723 6.723 0 0 1-.078-.181c-.45-1.1-.716-2.576-.716-4.485 0-3.084-2.088-5.616-4.667-5.616zM7.973 4.802a.667.667 0 0 1-.259.906 4.984 4.984 0 0 0-1.936 1.937.667.667 0 1 1-1.166-.647 6.317 6.317 0 0 1 2.454-2.455.667.667 0 0 1 .907.259zm8.962-.259a6.339 6.339 0 0 1 2.454 2.455.667.667 0 0 1-1.167.647 5.001 5.001 0 0 0-1.937-1.937.667.667 0 1 1 .65-1.165zm-9.65-2.059a.667.667 0 0 1-.458.824 5.11 5.11 0 0 0-3.519 3.52.667.667 0 0 1-1.283-.365 6.444 6.444 0 0 1 4.437-4.437c.354-.101.723.104.824.458zm10.253-.458a6.444 6.444 0 0 1 4.437 4.437.667.667 0 1 1-1.283.364 5.11 5.11 0 0 0-3.519-3.519.667.667 0 0 1 .365-1.282z"
  }));
};

AlertBell.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var AlertBrokenIntegration = function AlertBrokenIntegration(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M17.57 16.14a.58.58 0 0 1 .78-.24.55.55 0 0 1 .24.76L17 19.75a.58.58 0 0 1-.77.25.56.56 0 0 1-.25-.77zM19.81 18a.58.58 0 0 1-.77.25.57.57 0 0 1-.25-.77l.93-1.8a1.12 1.12 0 1 0-2-1l-.93 1.8a.59.59 0 0 1-.78.25.57.57 0 0 1-.24-.77l.93-1.8a2.27 2.27 0 0 1 4 2.08zm-5.06-.1a.58.58 0 0 1 .77-.25.56.56 0 0 1 .25.77l-.93 1.8a1.12 1.12 0 0 0 2 1l.93-1.79a.59.59 0 0 1 .78-.25.58.58 0 0 1 .25.77l-.94 1.8a2.27 2.27 0 0 1-4-2.09zM10.59 16a.72.72 0 1 1-.72-.72.72.72 0 0 1 .72.72zm-.72-1.76a.72.72 0 0 1-.72-.72V11a.72.72 0 1 1 1.44 0v2.57a.72.72 0 0 1-.72.7zm-7.69 4.29h9.16v1.57H.8a.78.78 0 0 1-.69-1.18L9.22 3.39a.8.8 0 0 1 1.37 0L16 12.22l-1.36.78-4.71-7.67z"
  })), /*#__PURE__*/_react["default"].createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M0 0h24v24H0z"
  }))), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M17.57 16.14a.58.58 0 0 1 .78-.24.55.55 0 0 1 .24.76L17 19.75a.58.58 0 0 1-.77.25.56.56 0 0 1-.25-.77zM19.81 18a.58.58 0 0 1-.77.25.57.57 0 0 1-.25-.77l.93-1.8a1.12 1.12 0 1 0-2-1l-.93 1.8a.59.59 0 0 1-.78.25.57.57 0 0 1-.24-.77l.93-1.8a2.27 2.27 0 0 1 4 2.08zm-5.06-.1a.58.58 0 0 1 .77-.25.56.56 0 0 1 .25.77l-.93 1.8a1.12 1.12 0 0 0 2 1l.93-1.79a.59.59 0 0 1 .78-.25.58.58 0 0 1 .25.77l-.94 1.8a2.27 2.27 0 0 1-4-2.09zM10.59 16a.72.72 0 1 1-.72-.72.72.72 0 0 1 .72.72zm-.72-1.76a.72.72 0 0 1-.72-.72V11a.72.72 0 1 1 1.44 0v2.57a.72.72 0 0 1-.72.7zm-7.69 4.29h9.16v1.57H.8a.78.78 0 0 1-.69-1.18L9.22 3.39a.8.8 0 0 1 1.37 0L16 12.22l-1.36.78-4.71-7.67z"
  }), /*#__PURE__*/_react["default"].createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/_react["default"].createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-5-2h31v30H-5z"
  }))));
};

AlertBrokenIntegration.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};

var AlertCircleSolid = function AlertCircleSolid(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12 2C6.486 2 2 6.486 2 12c0 5.515 4.486 10 10 10s10-4.485 10-10c0-5.514-4.486-10-10-10zm-1 4h2v7h-2V6zm1 11.25a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5z"
  }));
};

AlertCircleSolid.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};

var AlertCircle = function AlertCircle(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12 22C6.486 22 2 17.515 2 12 2 6.486 6.486 2 12 2s10 4.486 10 10c0 5.515-4.486 10-10 10zm0-18c-4.411 0-8 3.589-8 8s3.589 8 8 8 8-3.589 8-8-3.589-8-8-8z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11 6h2v7h-2z"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "12",
    cy: "16",
    r: "1.25"
  }));
};

AlertCircle.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};

var AlertEmailBounce = function AlertEmailBounce(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M22.3 21.247h-5.65a1.16 1.16 0 0 1-1.16-1.17v-3.76a1.17 1.17 0 0 1 1.16-1.18h5.65a1.16 1.16 0 0 1 1.15 1.18v3.76a1.16 1.16 0 0 1-1.15 1.17zm-.36-5.08H17l2.12 1.94a.49.49 0 0 0 .66 0l2.16-1.94zm.49.94l-1.93 1.76a1.51 1.51 0 0 1-2 0l-2-1.78v3c0 .077.063.14.14.14h5.66a.13.13 0 0 0 .13-.14v-2.98zm-10.84-1.11a.72.72 0 1 1-1.44 0 .72.72 0 0 1 1.44 0zm-.72-1.76a.72.72 0 0 1-.72-.72v-2.52a.72.72 0 0 1 1.44 0v2.57a.72.72 0 0 1-.72.7v-.03zm-7.69 4.29h9.16v1.57H1.8a.78.78 0 0 1-.69-1.18l9.11-15.53a.8.8 0 0 1 1.37 0l5.41 8.83-1.36.78-4.71-7.67-7.75 13.2z"
  }));
};

AlertEmailBounce.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var AlertNps = function AlertNps(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M2.182 18.526h9.155v1.579H.797a.79.79 0 0 1-.688-1.187L9.224 3.392a.8.8 0 0 1 1.369-.012L16 12.22l-1.362.818-4.712-7.703-7.744 13.191zm7.689-4.254a.723.723 0 0 1-.723-.722v-2.574a.723.723 0 0 1 1.446 0v2.574a.723.723 0 0 1-.723.722zm.723 1.758a.723.723 0 1 1-1.446-.002.723.723 0 0 1 1.446.002z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M14 15.097h.902l1.776 2.862h.011v-2.862h.68v3.823h-.863l-1.815-2.953h-.01v2.953H14v-3.823zm4.212 0h1.247c.22 0 .418.02.594.06.177.04.328.104.454.194.126.09.223.205.292.346.068.14.102.31.102.507 0 .213-.04.39-.119.535a.964.964 0 0 1-.32.348 1.409 1.409 0 0 1-.473.192c-.18.04-.371.06-.573.06h-.524v1.581h-.68v-3.823zm1.156 1.669c.111 0 .217-.008.318-.024a.88.88 0 0 0 .27-.087.493.493 0 0 0 .19-.17.507.507 0 0 0 .07-.28.483.483 0 0 0-.07-.273.485.485 0 0 0-.187-.165.798.798 0 0 0-.265-.079 2.415 2.415 0 0 0-.305-.018h-.497v1.096h.476zm4.087-.87a.826.826 0 0 0-.305-.235.91.91 0 0 0-.634-.064.724.724 0 0 0-.216.091.507.507 0 0 0-.16.162.446.446 0 0 0-.062.24.43.43 0 0 0 .203.379c.063.043.14.08.23.113s.188.065.296.097c.123.04.25.085.381.135.132.05.252.117.362.2.11.083.2.187.27.313s.105.283.105.47a1.2 1.2 0 0 1-.113.537c-.076.154-.177.28-.303.381a1.29 1.29 0 0 1-.442.227c-.17.05-.348.076-.535.076-.248 0-.491-.046-.729-.138a1.408 1.408 0 0 1-.583-.408l.486-.453c.093.13.218.232.375.307.157.076.31.114.462.114.079 0 .16-.01.243-.03a.648.648 0 0 0 .224-.1.508.508 0 0 0 .224-.437c0-.101-.023-.185-.07-.251a.628.628 0 0 0-.19-.173 1.357 1.357 0 0 0-.28-.127l-.34-.113a3.37 3.37 0 0 1-.346-.13 1.146 1.146 0 0 1-.31-.2.965.965 0 0 1-.224-.305 1.044 1.044 0 0 1-.087-.45.988.988 0 0 1 .44-.851c.132-.092.281-.16.448-.205a1.818 1.818 0 0 1 1.102.035c.2.068.374.17.521.307l-.443.486z"
  }));
};

AlertNps.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var AlertReviewInvite = function AlertReviewInvite(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M2.182 18.526h9.155v1.579H.797a.79.79 0 0 1-.688-1.187L9.224 3.392a.8.8 0 0 1 1.369-.012L16 12.22l-1.362.818-4.712-7.703-7.744 13.191zm7.689-4.254a.723.723 0 0 1-.723-.722v-2.574a.723.723 0 0 1 1.446 0v2.574a.723.723 0 0 1-.723.722zm.723 1.758a.723.723 0 1 1-1.446-.002.723.723 0 0 1 1.446.002zM15.317 17.318l.785.35 3.293-1.75c.535-.284 1.06.392.653.84l-2.171 2.387v.645l.632-.77a.54.54 0 0 1 .622-.158l1.734.708 1.005-6.032-6.553 3.78zm1.059 1.427a.54.54 0 0 1-.474.017l-1.444-.646a.804.804 0 0 1-.526-.722.8.8 0 0 1 .412-.761l7.441-4.293a.811.811 0 0 1 .424-.12c.167 0 .328.05.482.155.258.19.38.483.334.8l-.001.011-1.147 6.882a.832.832 0 0 1-.41.58.817.817 0 0 1-.717.042l-1.659-.678-.823 1.004a.801.801 0 0 1-.645.31.721.721 0 0 1-.285-.051.818.818 0 0 1-.39-.3.815.815 0 0 1-.151-.476v-1.563a.54.54 0 0 1 .14-.363l.222-.244-.783.416z"
  }));
};

AlertReviewInvite.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var AlertTriangle = function AlertTriangle(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M21.895 20.553l-9-18c-.339-.677-1.45-.677-1.789 0l-9 18A.999.999 0 0 0 3 22h18c.347 0 .668-.18.851-.474.182-.296.198-.662.044-.973zM11 10h2v6h-2v-6zm1 9.25a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5z"
  }));
};

AlertTriangle.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};

var Archive = function Archive(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M20 3.001H4c-1.104 0-2 .898-2 2v3a1 1 0 0 0 1 1v10c0 1.103.896 2 2 2h14c1.104 0 2-.897 2-2v-10a1 1 0 0 0 1-1v-3c0-1.102-.896-2-2-2zm0 2v2H4v-2h16zm-1 14H5v-10h14v10z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M9 10.001h6v3H9z"
  }));
};

Archive.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};

var Arrow = function Arrow(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16.707 7.293l-1.414 1.414L17.586 11H2v2h15.586l-2.293 2.293 1.414 1.413L21.414 12z"
  }));
};

Arrow.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};

var Block = function Block(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM4 12c0-4.42 3.58-8 8-8 1.85 0 3.55.63 4.9 1.69L5.69 16.9A7.902 7.902 0 0 1 4 12zm8 8c-1.85 0-3.55-.63-4.9-1.69L18.31 7.1A7.902 7.902 0 0 1 20 12c0 4.42-3.58 8-8 8z"
  }));
};

Block.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};

var Bookmark = function Bookmark(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16 2.001H8c-1.104 0-2 .897-2 2v17a1.002 1.002 0 0 0 1.707.707L12 17.415l4.293 4.293A1 1 0 0 0 18 21.001v-17c0-1.103-.896-2-2-2zm0 2v9.586l-3.293-3.293a.999.999 0 0 0-1.414 0L8 13.587V4.001h8zm-3.293 11.293a.999.999 0 0 0-1.414 0L8 18.587v-2.172l4-4 4 4v2.172l-3.293-3.293z"
  }));
};

Bookmark.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};

var Brackets = function Brackets(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M9.4 16.6L4.8 12l4.6-4.6L8 6l-6 6 6 6 1.4-1.4zm5.2 0l4.6-4.6-4.6-4.6L16 6l6 6-6 6-1.4-1.4z"
  }));
};

Brackets.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};

var BuildingCircle = function BuildingCircle(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12 24C5.373 24 0 18.627 0 12S5.373 0 12 0s12 5.373 12 12-5.373 12-12 12zM9.952 9.952h1.238V8.714H9.952v1.238zm2.476 0h1.238V8.714h-1.238v1.238zM9.952 12.43h1.238V11.19H9.952v1.239zm2.476 0h1.238V11.19h-1.238v1.239zm-4.952 2.476h1.238v-1.238H7.476v1.238zm2.476 0h1.238v-1.238H9.952v1.238zm2.476 0h1.238v-1.238h-1.238v1.238zm2.476 0h1.238v-1.238h-1.238v1.238zm1.857 1.857h-3.714v-1.238H10.57v1.238H6.856v-3.714h1.857a.62.62 0 0 0 .62-.62V7.477h1.238a.62.62 0 0 0 .619-.619v-.619h1.238v.62a.62.62 0 0 0 .619.618h1.238v4.953a.62.62 0 0 0 .619.619h1.857v3.714zm.62-4.952h-1.858V6.857a.62.62 0 0 0-.619-.619h-1.238V5.62a.62.62 0 0 0-.62-.619h-2.475a.62.62 0 0 0-.62.619v.62H8.714a.62.62 0 0 0-.619.618v4.953H6.237a.62.62 0 0 0-.619.619v4.952a.62.62 0 0 0 .62.619H17.38a.62.62 0 0 0 .62-.619v-4.952a.62.62 0 0 0-.62-.62z"
  }));
};

BuildingCircle.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var Building = function Building(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M9 6.999h2v2H9zM13 6.999h2v2h-2zM9 10.999h2v2H9zM13 10.999h2v2h-2zM5 14.999h2v2H5zM9 14.999h2v2H9zM13 14.999h2v2h-2zM17 14.999h2v2h-2z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M21 11.999h-3v-8c0-.551-.448-1-1-1h-2v-1c0-.551-.448-1-1-1h-4c-.552 0-1 .449-1 1v1H7c-.552 0-1 .449-1 1v8H3c-.552 0-1 .449-1 1v8a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1v-8a1 1 0 0 0-1-1zm-1 8h-6v-2h-4v2H4v-6h3a1 1 0 0 0 1-1v-8h2a1 1 0 0 0 1-1v-1h2v1a1 1 0 0 0 1 1h2v8a1 1 0 0 0 1 1h3v6z"
  }));
};

Building.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};

var CalendarAdd = function CalendarAdd(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16.81 10.81a5.952 5.952 0 1 1 0 11.904 5.952 5.952 0 0 1 0-11.904zm0 1.428a4.524 4.524 0 1 0 0 9.048 4.524 4.524 0 0 0 0-9.048zm0 1.429c.361 0 .66.268.707.617l.007.097v1.666h1.666a.714.714 0 0 1 .097 1.423l-.097.006h-1.666v1.667a.714.714 0 0 1-1.422.097l-.007-.097v-1.667h-1.666a.714.714 0 0 1-.097-1.422l.097-.006 1.666-.001v-1.666c0-.395.32-.714.715-.714zM13 1.6c.362 0 .66.269.708.617l.006.097v.876h2.273c1.054 0 1.93.79 2.007 1.806l.006.147v3.714a.714.714 0 0 1-1.422.097l-.007-.097v-.905H3.714v7.096c0 .253.206.475.488.516l.097.007h5.195a.714.714 0 0 1 .096 1.422L9.494 17H4.299c-1.054 0-1.93-.79-2.008-1.806l-.005-.146V5.143c0-1.037.828-1.873 1.863-1.947l.15-.006h1.32v-.876a.714.714 0 0 1 1.422-.097l.007.097-.001.876h5.239v-.876c0-.394.32-.714.714-.714zM5.619 4.619h-1.32c-.297 0-.533.196-.577.44l-.008.084v1.38H16.57v-1.38c0-.253-.205-.475-.487-.517l-.097-.007h-2.273v.552a.714.714 0 0 1-1.422.097l-.006-.097V4.62h-5.24l.002.552a.714.714 0 0 1-1.422.097l-.007-.097V4.62z",
    fillRule: "nonzero"
  }));
};

CalendarAdd.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var CalendarClock = function CalendarClock(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M14.375 8.75a5.625 5.625 0 1 1 0 11.25 5.625 5.625 0 0 1 0-11.25zm0 1.25a4.375 4.375 0 1 0 0 8.75 4.375 4.375 0 0 0 0-8.75zm-3.75-10c.316 0 .578.235.62.54l.005.085v.625h1.875c.992 0 1.805.771 1.87 1.747l.005.128v3.75a.625.625 0 0 1-1.244.085l-.006-.085V6.25H1.25v6.875c0 .316.235.578.54.62l.085.005h5a.625.625 0 0 1 .085 1.244L6.875 15h-5a1.875 1.875 0 0 1-1.87-1.747L0 13.125v-10c0-.992.771-1.805 1.747-1.87l.128-.005H3.75V.625A.625.625 0 0 1 4.994.54L5 .625v.625h5V.625c0-.345.28-.625.625-.625zm3.75 11.54c.316 0 .578.236.62.541l.005.085v1.584h1.585c.316 0 .578.235.62.54l.005.085a.625.625 0 0 1-.54.62l-.085.005h-2.21a.625.625 0 0 1-.62-.54l-.005-.085v-2.21c0-.344.28-.624.625-.624zM3.75 2.5H1.875a.625.625 0 0 0-.62.54l-.005.085V5h12.5V3.125a.625.625 0 0 0-.54-.62l-.085-.005H11.25v.625a.625.625 0 0 1-1.244.085L10 3.125V2.5H5v.625a.625.625 0 0 1-1.244.085l-.006-.085V2.5z",
    fillRule: "nonzero"
  }));
};

CalendarClock.defaultProps = {
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
};

var Calendar = function Calendar(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M9 2v3h7v2h1V2h2v3h1a2 2 0 0 1 2 2v13a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V7c0-1.1.9-2 2-2h2v2h1V2h2zm11 7H4v11h16V9z"
  }));
};

Calendar.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};

var ChatBubbleEmpty = function ChatBubbleEmpty(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M4 4v12h4v2l2.667-2H20V4H4zm2 18v-4H4c-1.103 0-2-.897-2-2V4c0-1.103.897-2 2-2h16c1.103 0 2 .897 2 2v12c0 1.103-.897 2-2 2h-8.667L6 22z"
  }));
};

ChatBubbleEmpty.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var ChatBubbleLine = function ChatBubbleLine(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M5.998 22v-4h-2c-1.103 0-2-.897-2-2V4c0-1.104.897-2 2-2h16c1.103 0 2 .896 2 2v12c0 1.103-.897 2-2 2h-8.667l-5.333 4zm-2-18v12h4v2l2.667-2h9.333V4h-16z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M5.998 6h12v2h-12zM5.998 9h12v2h-12zM5.998 12h8v2h-8z"
  }));
};

ChatBubbleLine.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};

var ChatBubble = function ChatBubble(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M19.998 2h-16a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h1v4l4-4h10.999a2 2 0 0 0 2-2V4c.001-1.105-.894-2-1.999-2zm-7 13h-7v-2h7v2zm5-4h-12V9h12v2zm0-4h-12V5h12v2z"
  }));
};

ChatBubble.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};

var ChatBubbles = function ChatBubbles(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M20.998 24l-5.334-4h-3.166c-.827 0-1.5-.673-1.5-1.5v-7c0-.827.673-1.5 1.5-1.5h10c.827 0 1.5.673 1.5 1.5v7c0 .827-.673 1.5-1.5 1.5h-1.5v4zm-8-6h3.334l2.666 2v-2h3v-6h-9v6z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M2.998 20v-4h-1.5c-.827 0-1.5-.673-1.5-1.5v-11c0-.827.673-1.5 1.5-1.5h13c.827 0 1.5.673 1.5 1.5v4.498h-2V4h-12v10h3v2l2.666-2h1.334v2h-.666l-5.334 4z"
  }));
};

ChatBubbles.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};

var CheckCircle = function CheckCircle(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.042 2c-5.523 0-10 4.477-10 10s4.477 10 10 10 10-4.477 10-10-4.478-10-10-10zm-.75 15.75l-5-3.75 1.5-2 3 2.25 5.25-7 2 1.5-6.75 9z"
  }));
};

CheckCircle.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};

var Check = function Check(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M19 5l2.121 2.121-12.06 12.061L3 13.122 5.121 11l3.94 3.94z"
  }));
};

Check.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var CheckboxBlankReadonly = function CheckboxBlankReadonly(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M3 13v-3h18v3z"
  }));
};

CheckboxBlankReadonly.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var Chevron = function Chevron(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
  }));
};

Chevron.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};

var Click = function Click(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M17.196 14.02L13 13.181V9a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v5H7a1.001 1.001 0 0 0-.895 1.448l3 6A1 1 0 0 0 10 22h7a1 1 0 0 0 1-1v-6a1 1 0 0 0-.804-.98z"
  }), /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M4 8h3v2H4zM6.757 3.344L8.88 5.465 7.465 6.88 5.343 4.76zM10 2h2v3h-2zM16.656 4.758L14.535 6.88 13.12 5.465l2.121-2.12zM15 8h3v2h-3z"
  })));
};

Click.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};

var Contributor = function Contributor(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16 19.132l-3.556-2.964a.67.67 0 0 0-.888 0L8 19.132V4h8v15.132zM7.714 2C6.77 2 6 2.898 6 4v17c0 .369.174.708.453.882a.754.754 0 0 0 .88-.05L12 18.202l4.667 3.63c.144.112.31.168.476.168a.762.762 0 0 0 .404-.118c.279-.174.453-.513.453-.882V4c0-1.102-.769-2-1.714-2H7.714z",
    fillRule: "evenodd"
  }));
};

Contributor.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var Copy = function Copy(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M14.5 3H9v14h10V3h-4.5zM21 3v14c0 1.1-.9 2-2 2H9c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2zM5 5v16h12v2H5c-1.1 0-2-.9-2-2V5h2z"
  }));
};

Copy.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};

var CreditCard = function CreditCard(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M9.048 14.479L2.913 8.344v-3.43h9.17l6.134 6.135v3.43H9.048zm-6.135-3.43l3.43 3.43h-3.43v-3.43zm15.304-2.706l-3.43-3.43h3.43v3.43zm1.914 7.092V3.957A.957.957 0 0 0 19.174 3H1.957A.957.957 0 0 0 1 3.957v11.478c0 .528.429.957.957.957h17.217a.957.957 0 0 0 .957-.957z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10.565 11.13A1.437 1.437 0 0 1 9.13 9.697c0-.79.644-1.435 1.435-1.435S12 8.905 12 9.696s-.644 1.435-1.435 1.435m0-4.783a3.352 3.352 0 0 0-3.348 3.348 3.352 3.352 0 0 0 3.348 3.348 3.352 3.352 0 0 0 3.348-3.348 3.352 3.352 0 0 0-3.348-3.348"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M21.087 6.827v10.521H4.827v1.913h17.216a.957.957 0 0 0 .957-.956V6.827h-1.913z"
  })));
};

CreditCard.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var Crown = function Crown(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M21.625 9.221a1 1 0 0 0-1.072-.114l-5.172 2.586-2.523-4.206c-.361-.603-1.354-.603-1.715 0L8.62 11.693 3.447 9.106a1 1 0 0 0-1.418 1.137l1.789 7.153A1.993 1.993 0 0 0 3 19.001v1c0 1.103.896 2 2 2h14c1.104 0 2-.897 2-2v-1a1.99 1.99 0 0 0-.818-1.604l1.789-7.153a1.004 1.004 0 0 0-.346-1.023zM8.553 13.896a1.001 1.001 0 0 0 1.305-.38L12 9.944l2.143 3.571c.269.448.838.613 1.305.38l4.055-2.027-1.283 5.133H5.781l-1.283-5.133 4.055 2.028zm10.444 6.105H5v-1h14l-.003 1z"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "12",
    cy: "4.001",
    r: "2"
  })));
};

Crown.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};

var CustomerJourney = function CustomerJourney(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    className: "st1",
    d: "M12 9.7h1.9V7.3L16.8 5v3.8h1.9V3c0-.4-.2-.7-.5-.9-.3-.2-.7-.1-1 .1L13 5.6 8.8 2.2c-.2-.1-.4-.2-.7-.2-.2 0-.4.1-.6.2L2.7 6.1c-.2.2-.3.4-.3.7v13.5c0 .4.2.7.5.9.1.1.3.1.4.1.2 0 .4-.1.6-.2l4.8-3.9c.2-.2.4-.5.4-.8V5L12 7.3v2.4zM4.3 7.3L7.2 5v11l-2.9 2.3v-11z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "st1",
    d: "M22.4 20.6l-2.5-2.5c.5-.8.8-1.7.8-2.7 0-2.7-2.2-4.8-4.8-4.8S11 12.9 11 15.5s2.2 4.8 4.8 4.8c1 0 1.9-.3 2.7-.8L21 22l1.4-1.4zm-6.5-2.2c-1.6 0-2.9-1.3-2.9-2.9s1.3-2.9 2.9-2.9 2.9 1.3 2.9 2.9-1.3 2.9-2.9 2.9z"
  }));
};

CustomerJourney.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var Desktop = function Desktop(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M3.7 15h16.7v.9H3.7V15zM20.3 4.7v8.6H3.7V4.7h16.6zm0-1.7H3.7C2.7 3 2 3.8 2 4.7v11.1c0 .9.7 1.7 1.7 1.7h7.5v1.7H7.8V21h8.3v-1.7h-3.3v-1.7h7.5c.9 0 1.7-.8 1.7-1.7V4.7c0-.9-.7-1.7-1.7-1.7z"
  }));
};

Desktop.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};

var DownloadSquareSolid = function DownloadSquareSolid(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M19 3.001H5c-1.103 0-2 .897-2 2v14c0 1.102.897 2 2 2h14c1.104 0 2-.898 2-2v-14c0-1.103-.896-2-2-2zm-7 14.414l-4.707-4.707 1.414-1.414L11 13.587V7.001h2v6.586l2.293-2.293 1.414 1.414L12 17.415z"
  }));
};

DownloadSquareSolid.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};

var DownloadSquare = function DownloadSquare(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M19 3.001H5a2 2 0 0 0-2 2v14c0 1.102.896 2 2 2h14c1.104 0 2-.898 2-2v-14a2 2 0 0 0-2-2zm-.003 16H5v-14h14l-.003 14z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16.707 12.708l-1.414-1.414L13 13.587V7.001h-2v6.586l-2.293-2.293-1.414 1.414L12 17.415z"
  }));
};

DownloadSquare.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};

var Download = function Download(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M17.707 10.708l-1.414-1.414L13 12.587V2.001h-2v10.586L7.707 9.294l-1.414 1.414L12 16.415zM18 18.001v2H6v-2H4v2c0 1.102.897 2 2 2h12c1.104 0 2-.898 2-2v-2h-2z"
  })));
};

Download.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};

var Dustpan = function Dustpan(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M19.146 14.92l-.875 4.198a1.508 1.508 0 0 1-1.481 1.257H7.212a1.5 1.5 0 0 1-1.478-1.232l-.88-4.222a1 1 0 0 0-1.958.408l.875 4.198c.299 1.64 1.749 2.85 3.441 2.848h9.578a3.5 3.5 0 0 0 3.444-2.873l.87-4.173a1 1 0 0 0-1.958-.408z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M13.982 16.625h-3.964a.249.249 0 0 1-.136-.04l-1.181-1.671-.11-.13A2.25 2.25 0 0 0 7 14.125H2.625a1 1 0 0 0 0 2H7c.049 0 .096.014.136.04l1.182 1.671.11.13c.42.422.993.659 1.59.659h3.964c.597 0 1.17-.237 1.59-.659l.11-.13 1.182-1.671a.252.252 0 0 1 .136-.04h4.375a1 1 0 0 0 0-2H17a2.25 2.25 0 0 0-1.591.659l-.11.13-1.181 1.671a.249.249 0 0 1-.136.04zm-4.14-.073l-.708.707.817-.577-.069-.097a.25.25 0 0 1-.04-.033z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M18.793 1.918a1 1 0 0 1 1.414 1.414L15.47 8.071l.126.31c.12.313.204.58.255.853.167.881-.033 1.701-.658 2.534l-1.732 2.31a1.652 1.652 0 0 1-2.493.178L7.87 11.158a1.653 1.653 0 0 1 .177-2.493l2.31-1.732c.755-.567 1.5-.786 2.299-.69.334.039.657.129 1.042.273.073.028.209.082.355.142zm-7.237 6.615l-1.991 1.493 2.534 2.534 1.493-1.992c.293-.39.354-.641.293-.961-.043-.23.017-.083-.363-1.005a29.98 29.98 0 0 0-.529-.214 2.53 2.53 0 0 0-.575-.16c-.27-.032-.506.037-.862.305z"
  })));
};

Dustpan.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var EnvelopeLine = function EnvelopeLine(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M20 7H4c-1.103 0-2 .897-2 2v9c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V9c0-1.103-.897-2-2-2zm-1.887 2L12 12.82 5.887 9h12.226zM4 18v-7.821l7.47 4.669a1.002 1.002 0 0 0 1.06 0l7.47-4.67.001 7.822H4z"
  }));
};

EnvelopeLine.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};

var Envelope = function Envelope(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12 10.823l8.965-5.563A1.977 1.977 0 0 0 20 5H4c-.352 0-.678.1-.965.26L12 10.823z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.527 12.849a1 1 0 0 1-1.054.001l-9.47-5.877c0 .009-.003.018-.003.026v9c0 1.102.897 2 2 2h16c1.103 0 2-.898 2-2v-9l-.003-.027-9.47 5.877z"
  })));
};

Envelope.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};

var Expand = function Expand(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10 7.999v-2H4c-1.103 0-2 .897-2 2v12c0 1.104.897 2 2 2h12a2 2 0 0 0 2-2v-6h-2v6H4v-12h6z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M21 2.999h-7v2h3.586L6.293 16.292l1.414 1.414L19 6.413v3.586h2z"
  })));
};

Expand.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};

var EyeSlashed = function EyeSlashed(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M22.827 11.456c-.096-.148-1.522-2.282-4.101-3.979l3.97-3.971-1.414-1.414L1.811 21.564l1.414 1.414 5.146-5.146c1.093.341 2.298.554 3.618.554 6.804 0 10.667-5.585 10.828-5.824l.373-.548-.363-.558zm-10.839 4.93a9.873 9.873 0 0 1-1.968-.204l1.907-1.907c.252.069.515.111.79.111a3 3 0 0 0 3-3c0-.274-.042-.538-.111-.79l1.661-1.661a13.848 13.848 0 0 1 3.464 3.052c-1.087 1.29-4.182 4.399-8.743 4.399zm-7.384-.444l1.453-1.453a13.823 13.823 0 0 1-2.812-2.503c1.07-1.336 4.154-4.6 8.744-4.6.378 0 .742.029 1.099.072l1.716-1.716a11.506 11.506 0 0 0-2.815-.356c-6.816 0-10.678 5.822-10.838 6.07l-.362.558.373.548c.086.129 1.278 1.845 3.442 3.38z"
  }));
};

EyeSlashed.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};

var Eye = function Eye(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.023 16.846c3.276 0 6.08-1.525 8.51-4.701-2.48-3.377-5.288-4.991-8.51-4.991-3.222 0-6.043 1.614-8.548 4.99 2.454 3.177 5.271 4.702 8.548 4.702zM1 12.167C4.063 7.39 7.738 5 12.023 5 16.308 5 19.967 7.39 23 12.167 20.023 16.722 16.364 19 12.023 19 7.683 19 4.008 16.722 1 12.167zm11.196-3.505a2.946 2.946 0 0 0-2.946 2.946v.569a2.946 2.946 0 0 0 5.893 0v-.569a2.946 2.946 0 0 0-2.947-2.946z"
  }));
};

Eye.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var FaceAngry = function FaceAngry(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12 2C6.486 2 2 6.486 2 12c0 5.515 4.486 10 10 10s10-4.485 10-10c0-5.514-4.486-10-10-10zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M6.416 15.271l1.396 1.433A5.969 5.969 0 0 1 12 15c1.604 0 3.11.624 4.242 1.757l1.415-1.414A7.944 7.944 0 0 0 12 13a7.96 7.96 0 0 0-5.584 2.271zM16.292 7.293l1.413 1.413-3 3.001-1.413-1.413zM7.707 7.293l3 3-1.413 1.414-3-3z"
  })));
};

FaceAngry.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};

var FaceHappy = function FaceHappy(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M9 10.414l1.293 1.293 1.414-1.414L9 7.586l-2.707 2.707 1.414 1.414zM15 7.586l-2.707 2.707 1.414 1.414L15 10.414l1.293 1.293 1.414-1.414z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12 2C6.486 2 2 6.486 2 12c0 5.515 4.486 10 10 10s10-4.485 10-10c0-5.514-4.486-10-10-10zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12 16a3.972 3.972 0 0 1-3.199-1.598l-1.598 1.204A5.958 5.958 0 0 0 12 18a5.955 5.955 0 0 0 4.8-2.398L15.2 14.4A3.968 3.968 0 0 1 12 16z"
  })));
};

FaceHappy.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};

var FaceMeh = function FaceMeh(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12 2C6.486 2 2 6.486 2 12c0 5.515 4.486 10 10 10s10-4.485 10-10c0-5.514-4.486-10-10-10zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M8 15h8v2H8zM8 8h2v3H8zM14 8h2v3h-2z"
  })));
};

FaceMeh.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};

var FacebookMessenger = function FacebookMessenger(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12 2C6.478 2 2 6.145 2 11.257c0 2.908 1.449 5.503 3.715 7.2V22l3.413-1.874c.935.258 1.901.389 2.872.388 5.522 0 10-4.145 10-9.257S17.523 2 12 2zm1.042 12.521l-2.608-2.623-5.022 2.69 5.506-5.66 2.608 2.624 5.023-2.69-5.507 5.66z"
  }));
};

FacebookMessenger.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var Feedback = function Feedback(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M4.74 9.742a.75.75 0 0 1-.74-.76.75.75 0 0 1 .74-.762h7.102c.409 0 .74.34.74.761a.75.75 0 0 1-.74.761H4.74zm10.684 1.675c.408 0 .74.34.74.76a.75.75 0 0 1-.74.762H4.74a.75.75 0 0 1-.74-.761.75.75 0 0 1 .74-.761h10.684zm-3.582 3.196c.409 0 .74.341.74.761a.75.75 0 0 1-.74.761H4.74a.75.75 0 0 1-.74-.76.75.75 0 0 1 .74-.762h7.102zm9.215-7.431A7.507 7.507 0 0 1 23 12.249c0 1.89-.69 3.689-1.944 5.066-1.28 1.407-2.98 2.182-4.787 2.182h-5.39l-1.654 1.682-1.398 1.438c-.243.25-.53.383-.809.383a.88.88 0 0 1-.345-.07c-.377-.161-.601-.558-.601-1.061v-3.898h1.482v2.77l.626-.643 1.805-1.836c.255-.262.6-.29.737-.29h5.548c2.844 0 5.247-2.621 5.247-5.723 0-3.103-2.403-5.724-5.248-5.724H6.072V5.98c0-.558.427-.979.993-.979h9.204c1.808 0 3.508.775 4.788 2.182z",
    fillRule: "nonzero"
  }));
};

Feedback.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var FileAudio = function FileAudio(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16.414 1.003H5c-1.103 0-2 .897-2 2v18c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V5.589l-4.586-4.586zM5 21.003v-18h10v4h4l.001 14H5z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11 13.05a2.5 2.5 0 1 0 2 2.45v-5.112l2.632.877.633-1.898L11 7.612v5.438z"
  })));
};

FileAudio.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};

var FileBlank = function FileBlank(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M15.414 2H6c-1.103 0-2 .898-2 2v16c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2V6.586L15.414 2zm2.587 18H6V4h8v4h4l.001 12z"
  }));
};

FileBlank.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};

var FileCoding = function FileCoding(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10.293 10.299l-3.707 3.707 3.707 3.708 1.414-1.415-2.293-2.293 2.293-2.292zM12.293 11.714l2.293 2.292-2.293 2.293 1.414 1.415 3.707-3.708-3.707-3.707z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16.414 1.003H5c-1.103 0-2 .896-2 2v18c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V5.59l-4.586-4.587zM5 21.003v-18h10v4h4l.001 14H5z"
  })));
};

FileCoding.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};

var FileCopy = function FileCopy(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16.414 1H9c-1.103 0-2 .898-2 2v14c0 1.103.897 2 2 2h10c1.103 0 2-.897 2-2V5.586L16.414 1zm2.587 16H9V3h6v4h4l.001 10z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M5 5H3v16c0 1.103.897 2 2 2h12v-2H5V5z"
  })));
};

FileCopy.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};

var FileCsv = function FileCsv(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M5 3.003h10v4h4v1h2V5.59l-4.586-4.586H5c-1.103 0-2 .896-2 2v5h2V3.003zM19 21.003H5v-1H3v1c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2v-1h-2v1zM8 18.003v-2H5c-.551 0-1-.448-1-1v-2c0-.55.449-1 1-1h3v-2H5c-1.654 0-3 1.346-3 3v2c0 1.654 1.346 3 3 3h3zM11.5 12.003H15v-2h-3.5a2.503 2.503 0 0 0-2.5 2.5c0 1.379 1.122 2.5 2.5 2.5h1a.5.5 0 0 1 0 1H9v2h3.5c1.378 0 2.5-1.121 2.5-2.5 0-1.378-1.122-2.5-2.5-2.5h-1a.5.5 0 0 1 0-1zM19.942 10.003l-.957 3.902L18 10.003h-2l1.963 8h2.058L20 17.922l2-7.919z"
  })));
};

FileCsv.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};

var FileDollar = function FileDollar(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M13 9h-2v1.051c-1.14.232-2 1.242-2 2.449 0 1.378 1.122 2.5 2.5 2.5h1a.5.5 0 0 1 0 1H9v2h2v1h2v-1.051c1.14-.232 2-1.243 2-2.449 0-1.378-1.122-2.5-2.5-2.5h-1a.5.5 0 0 1 0-1H15v-2h-2V9z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16.414 1H5c-1.103 0-2 .898-2 2v18c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V5.586L16.414 1zM5 21V3h10v4h4l.001 14H5z"
  }));
};

FileDollar.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};

var FilePdf = function FilePdf(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M5 3h10v4h4v1h2V5.586L16.414 1H5c-1.103 0-2 .898-2 2v5h2V3zM19 21H5v-1H3v1c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2v-1h-2v1zM9 10v8h2c2.206 0 4-1.794 4-4s-1.794-4-4-4H9zm4 4c0 1.103-.897 2-2 2v-4c1.103 0 2 .898 2 2zM22 12v-2h-4c-1.103 0-2 .898-2 2v6h2v-3h3v-2h-3v-1h4zM4 16h1c1.654 0 3-1.346 3-3s-1.346-3-3-3H2v8h2v-2zm0-4h1a1.001 1.001 0 0 1 0 2H4v-2z"
  })));
};

FilePdf.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};

var FileText = function FileText(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M7 10v4h2v-2h2v5H9v2h6v-2h-2v-5h2v2h2v-4z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16.414 1H5c-1.103 0-2 .898-2 2v18c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V5.586L16.414 1zM5 21V3h10v4h4l.001 14H5z"
  })));
};

FileText.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};

var FileVideo = function FileVideo(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M9 18.004l7-4-7-4z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16.414 1.004H5c-1.103 0-2 .898-2 2v18c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V5.59l-4.586-4.586zM5 21.004v-18h10v4h4l.001 14H5z"
  })));
};

FileVideo.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};

var FileZip = function FileZip(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M18 2H6c-1.103 0-2 .896-2 2v16c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2V4c0-1.104-.897-2-2-2zM6 20V4h6v2h2V4h4l.001 16H6z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M14 6h2v2h-2zM12 8h2v2h-2zM14 10h2v2h-2zM12 12h2v2h-2z"
  })));
};

FileZip.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};

var File = function File(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M15.414 2H6c-1.103 0-2 .898-2 2v16c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2V6.586L15.414 2zm2.587 18H6V4h8v4h4l.001 12z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M8 11h6v2H8zM8 15h8v2H8z"
  })));
};

File.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};

var Filter = function Filter(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M19 8.999c1.654 0 3-1.346 3-3s-1.346-3-3-3a2.993 2.993 0 0 0-2.815 2H2v2h14.185a2.993 2.993 0 0 0 2.815 2zm0-4a1 1 0 1 1 0 2 1 1 0 0 1 0-2zM9 8.999a2.993 2.993 0 0 0-2.815 2H2v2h4.185c.414 1.162 1.514 2 2.815 2s2.401-.838 2.815-2H22v-2H11.815a2.993 2.993 0 0 0-2.815-2zm0 4a1 1 0 1 1 0-2 1 1 0 0 1 0 2zM19 14.999a2.993 2.993 0 0 0-2.815 2H2v2h14.185a2.994 2.994 0 0 0 2.815 2c1.654 0 3-1.346 3-3s-1.346-3-3-3zm0 4a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"
  })));
};

Filter.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};

var Formatting = function Formatting(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M2.5 18.3l1.12-3.54h5.46l1.14 3.54h2.76L8.26 4H4.78L0 18.3h2.5zm5.96-5.48H4.24l2.12-6.64 2.1 6.64zm9.24 5.68c1.6 0 2.52-.58 3.2-1.48v1.28h2.38v-6.86c0-2.86-1.84-3.82-4.18-3.82s-4.28 1.02-4.48 3.46h2.34c.12-1.04.74-1.64 2-1.64 1.42 0 1.9.7 1.9 2.1v.54h-1.3c-3 0-5.36.88-5.36 3.32 0 2.18 1.58 3.1 3.5 3.1zm.58-1.74c-1.2 0-1.68-.58-1.68-1.46 0-1.28 1.18-1.7 3.02-1.7h1.24v1.04c0 1.34-1.1 2.12-2.58 2.12z"
  }));
};

Formatting.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var Gear = function Gear(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.498 16.466a3.966 3.966 0 1 1 .001-7.933 3.966 3.966 0 0 1 0 7.933zm0-1.6a2.367 2.367 0 0 0 0-4.733 2.366 2.366 0 0 0 0 4.733zM22 10.116a.8.8 0 0 1 .8.8v3.166a.8.8 0 0 1-.8.8h-1.117a8.664 8.664 0 0 1-.774 1.853l.794.793a.8.8 0 0 1 0 1.132l-2.236 2.24a.8.8 0 0 1-1.131 0l-.796-.795c-.589.331-1.21.592-1.855.777V22a.8.8 0 0 1-.8.8h-3.166a.8.8 0 0 1-.8-.8v-1.117a8.617 8.617 0 0 1-1.855-.775l-.794.795a.8.8 0 0 1-1.131 0l-2.24-2.236a.8.8 0 0 1-.001-1.132l.796-.797a8.605 8.605 0 0 1-.777-1.856H3a.8.8 0 0 1-.8-.8v-3.166a.8.8 0 0 1 .8-.8h1.117a8.648 8.648 0 0 1 .775-1.855l-.794-.794a.8.8 0 0 1 0-1.132l2.239-2.238a.8.8 0 0 1 1.131 0l.795.794c.588-.33 1.209-.59 1.854-.774V3a.8.8 0 0 1 .8-.8h3.166a.8.8 0 0 1 .8.8v1.117a8.63 8.63 0 0 1 1.853.773l.796-.796a.8.8 0 0 1 1.131 0l2.239 2.238a.8.8 0 0 1 0 1.132l-.796.796c.33.588.592 1.21.777 1.856H22zm-.8 1.6h-.945a.8.8 0 0 1-.783-.64 7.064 7.064 0 0 0-1.044-2.495.8.8 0 0 1 .101-1.008l.676-.675-1.107-1.107-.676.675a.8.8 0 0 1-1.007.101 7.039 7.039 0 0 0-2.49-1.038.8.8 0 0 1-.642-.784V3.8h-1.566v.945a.8.8 0 0 1-.641.784 7.033 7.033 0 0 0-2.492 1.04.8.8 0 0 1-1.008-.101l-.674-.674L5.795 6.9l.674.674a.8.8 0 0 1 .1 1.008 7.054 7.054 0 0 0-1.04 2.493.8.8 0 0 1-.784.64H3.8v1.566h.945a.8.8 0 0 1 .783.64c.182.89.536 1.731 1.043 2.492a.8.8 0 0 1-.1 1.01l-.676.676 1.108 1.106.674-.675a.8.8 0 0 1 1.009-.101 7.023 7.023 0 0 0 2.491 1.041.8.8 0 0 1 .642.784v.945h1.566v-.945a.8.8 0 0 1 .64-.784 7.067 7.067 0 0 0 2.493-1.043.8.8 0 0 1 1.007.1l.675.675 1.106-1.108-.673-.673a.8.8 0 0 1-.102-1.007 7.072 7.072 0 0 0 1.04-2.493.8.8 0 0 1 .784-.64h.945v-1.566z"
  }));
};

Gear.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var GiftOpen = function GiftOpen(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M18.953 9.125a.75.75 0 0 1 .75.75v3.75a.75.75 0 0 1-.75.75h-.501V20.5a2 2 0 0 1-1.85 1.995l-.15.005h-8.75a2 2 0 0 1-2-2v-6.125h-.5a.75.75 0 0 1-.743-.648l-.006-.102v-3.75a.75.75 0 0 1 .75-.75zm-7.626 5.25H7.202V20.5a.5.5 0 0 0 .41.492l.09.008h3.625v-6.625zm5.625 0h-4.125V21h3.626a.5.5 0 0 0 .491-.41l.009-.09-.001-6.125zm-5.625-3.75H5.952v2.25h5.375v-2.25zm6.875 0h-5.375v2.25h5.375v-2.25zm2.646-3.776a.75.75 0 0 1-.315.934l-.091.046-1.155.478a.75.75 0 0 1-.665-1.34l.091-.046 1.155-.478a.75.75 0 0 1 .98.406zM4.19 6.41l.097.033 1.155.478a.75.75 0 0 1-.477 1.419l-.097-.033-1.155-.478A.75.75 0 0 1 4.19 6.41zm3.075-2.763l.084.073.884.884a.75.75 0 0 1-.977 1.133l-.084-.073-.884-.884a.75.75 0 0 1 .977-1.133zm10.602.073a.75.75 0 0 1 .073.976l-.073.084-.884.884a.75.75 0 0 1-1.133-.976l.072-.084.884-.884a.75.75 0 0 1 1.061 0zm-5.79-1.47a.75.75 0 0 1 .744.648l.007.102v1.25a.75.75 0 0 1-1.494.102l-.006-.102V3a.75.75 0 0 1 .75-.75z",
    fillRule: "nonzero"
  }));
};

GiftOpen.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var Globe = function Globe(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    className: "st0",
    d: "M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm0 18c-4.4 0-8-3.6-8-8 0-2 .8-3.9 2-5.3V12h2.3l2.2 6.6 5.5-4.1V8h-3V4.1c3.9.5 7 3.9 7 7.9 0 4.4-3.6 8-8 8zM8 5.1c.9-.5 1.9-.9 3-1V10h3v3.5l-2.5 1.9L9.7 10H8V5.1z"
  }));
};

Globe.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};

var GoogleMessage = function GoogleMessage(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zM9.843 13.72v1.23c0 .018.015.032.033.032h5.122l1.984 1.993V9.702a.033.033 0 0 0-.033-.032h-1.311v4.05H9.843zm-1.789-5.7a.033.033 0 0 0-.033.032v6.568l1.792-1.8h4.896a.033.033 0 0 0 .033-.033V8.052a.033.033 0 0 0-.033-.032H8.054z"
  }));
};

GoogleMessage.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var GraphBar = function GraphBar(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M2 22h20v2H2zM10 15h4v6h-4zM16 9.001h4V21h-4zM4 13h4v8H4z"
  })));
};

GraphBar.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};

var GraphPie = function GraphPie(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M13 2h-1v10h10v-1c0-4.961-4.037-9-9-9z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10 14.002v-9.94l-.124.016A9.005 9.005 0 0 0 2 13c0 4.963 4.037 9 9 9a9.005 9.005 0 0 0 8.922-7.877l.016-.122H10z"
  })));
};

GraphPie.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};

var Hamburger = function Hamburger(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"
  }));
};

Hamburger.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};

var Inbox = function Inbox(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16.707 8.707l-1.414-1.414L13 9.586V1h-2v8.586L8.707 7.293 7.293 8.707 12 13.414zM15.586 14l-2 2h-3.172l-2-2H2v8h20v-8h-6.414zM20 20H4v-4h3.586l2 2h4.828l2-2H20v4z"
  })));
};

Inbox.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};

var Info = function Info(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12 22C6.486 22 2 17.515 2 12 2 6.487 6.486 2 12 2s10 4.486 10 10c0 5.515-4.486 10-10 10zm0-18c-4.411 0-8 3.589-8 8s3.589 8 8 8 8-3.589 8-8-3.589-8-8-8z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M13 15v-4a1 1 0 0 0-1-1h-2v2h1v3H9v2h6v-2h-2z"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "12",
    cy: "8",
    r: "1.25"
  }));
};

Info.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};

var Intercom = function Intercom(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M15.6 9.896a.6.6 0 0 1-1.2 0V4.5a.6.6 0 0 1 1.2 0v5.396zm-.21 3.756c-.092.08-2.315 1.944-6.39 1.944-4.075 0-6.298-1.865-6.39-1.944a.6.6 0 0 1 .78-.912c.034.03 2.02 1.656 5.61 1.656 3.636 0 5.59-1.639 5.61-1.655a.6.6 0 1 1 .78.91zM2.4 4.5a.6.6 0 0 1 1.2 0v5.396a.6.6 0 0 1-1.2 0V4.5zm3-1.2a.6.6 0 0 1 1.2 0v8.016a.6.6 0 0 1-1.2 0V3.3zm3-.304a.6.6 0 1 1 1.2 0v8.7a.6.6 0 0 1-1.2 0v-8.7zm3 .304a.6.6 0 0 1 1.2 0v8.016a.6.6 0 0 1-1.2 0V3.3zM15.75 0H2.25A2.25 2.25 0 0 0 0 2.25v13.5A2.25 2.25 0 0 0 2.25 18h13.5A2.25 2.25 0 0 0 18 15.75V2.25A2.25 2.25 0 0 0 15.75 0z"
  }));
};

Intercom.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var Layout = function Layout(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M8.71 1.254H3.448a2.19 2.19 0 0 0-2.19 2.19v5.264c0 1.21.98 2.19 2.19 2.19h5.264c1.21 0 2.19-.98 2.19-2.19V3.445a2.19 2.19 0 0 0-2.19-2.191zm-5.263 1.75h5.264a.44.44 0 0 1 .44.44v5.264a.44.44 0 0 1-.44.44H3.447a.441.441 0 0 1-.44-.44V3.445a.44.44 0 0 1 .44-.441zM8.71 13.096H3.448a2.19 2.19 0 0 0-2.19 2.19v5.264c0 1.21.98 2.19 2.19 2.19h5.264c1.21 0 2.19-.98 2.19-2.19v-5.263c0-1.21-.98-2.19-2.19-2.19zm-5.263 1.75h5.264a.44.44 0 0 1 .44.44v5.264a.44.44 0 0 1-.44.44H3.447a.441.441 0 0 1-.44-.44v-5.263a.44.44 0 0 1 .44-.44zM20.553 1.254h-5.264a2.19 2.19 0 0 0-2.19 2.19v5.264c0 1.21.98 2.19 2.19 2.19h5.264c1.21 0 2.19-.98 2.19-2.19V3.445a2.19 2.19 0 0 0-2.19-2.191zm-5.264 1.75h5.264a.44.44 0 0 1 .44.44v5.264a.44.44 0 0 1-.44.44h-5.264a.441.441 0 0 1-.44-.44V3.445a.44.44 0 0 1 .44-.441zm5.264 10.092h-5.264a2.19 2.19 0 0 0-2.19 2.19v5.264c0 1.21.98 2.19 2.19 2.19h5.264c1.21 0 2.19-.98 2.19-2.19v-5.263c0-1.21-.98-2.19-2.19-2.19zm-5.264 1.75h5.264a.44.44 0 0 1 .44.44v5.264a.44.44 0 0 1-.44.44h-5.264a.441.441 0 0 1-.44-.44v-5.263a.44.44 0 0 1 .44-.44z"
  }));
};

Layout.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var LightBulb = function LightBulb(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M7.875 20.125h1.75V21h1.75v-.875h1.75v-1.75h-5.25zm4.083-5.505a.875.875 0 0 0-.584.825v.305h-1.75v-.305a.876.876 0 0 0-.582-.825 4.382 4.382 0 0 1-2.918-4.12A4.38 4.38 0 0 1 10.5 6.125a4.38 4.38 0 0 1 4.375 4.375 4.38 4.38 0 0 1-2.916 4.12m-1.46-10.245A6.132 6.132 0 0 0 4.374 10.5a6.136 6.136 0 0 0 3.5 5.53v.595c0 .483.392.875.875.875h3.5a.875.875 0 0 0 .875-.875v-.596a6.135 6.135 0 0 0 3.5-5.529A6.132 6.132 0 0 0 10.5 4.375"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.375 0h-1.75v3.5h1.75zM0 11.375h3.5v-1.75H0zm17.5 0H21v-1.75h-3.5zm1.493-8.131l-1.237-1.238-2.625 2.625 1.237 1.238zM5.868 4.631L3.243 2.006 2.006 3.244l2.625 2.625z"
  })));
};

LightBulb.defaultProps = {
  viewBox: "0 0 21 21",
  xmlns: "http://www.w3.org/2000/svg"
};

var List = function List(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M3.026 17.872l.12.007a1.026 1.026 0 1 1-.24 0l.12-.007zm18.363.256c.337 0 .611.345.611.77 0 .386-.226.705-.521.76l-.09.009H6.714c-.338 0-.611-.345-.611-.77 0-.386.226-.706.52-.76l.091-.009h14.675zM3.026 12.744l.12.006a1.026 1.026 0 1 1-.24 0l.12-.006zM21.389 13c.337 0 .611.344.611.77 0 .385-.226.705-.521.76l-.09.008H6.714c-.338 0-.611-.344-.611-.769 0-.386.226-.706.52-.76L6.715 13H21.39zM3.026 8.128l.12.007a1.026 1.026 0 1 1-.24 0l.12-.007zm18.363 0c.337 0 .611.345.611.77 0 .386-.226.705-.521.76l-.09.009H6.714c-.338 0-.611-.345-.611-.77 0-.386.226-.706.52-.76l.091-.009h14.675zM3.026 3l.12.007a1.026 1.026 0 1 1-.24 0L3.026 3zm18.363.256c.337 0 .611.345.611.77 0 .386-.226.706-.521.76l-.09.009H6.714c-.338 0-.611-.345-.611-.77 0-.386.226-.705.52-.76l.091-.009h14.675z"
  }));
};

List.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var LocationAdmin = function LocationAdmin(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M18 14c0 2.549-4.018 4.969-6 5.903-1.984-.932-6-3.347-6-5.903V8h12v6zm0-8H6V4h12v2zm0-4H6c-1.103 0-2 .897-2 2v10c0 4.529 6.828 7.586 7.606 7.919.126.055.26.081.394.081a.982.982 0 0 0 .394-.081C13.172 21.586 20 18.529 20 14V4c0-1.103-.897-2-2-2z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M13 12l-1-3-1 3H8l2 2-1 3 3-2 3 2-1-3 2-2z"
  })));
};

LocationAdmin.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var LocationCircle = function LocationCircle(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12 24C5.373 24 0 18.627 0 12S5.373 0 12 0s12 5.373 12 12-5.373 12-12 12zm-.01-17.7c1.045 0 1.895.875 1.895 1.95 0 .768-1.006 3.42-1.895 5.543-.889-2.123-1.895-4.774-1.895-5.543 0-1.075.85-1.95 1.895-1.95zm0 9.75a.63.63 0 0 0 .575-.38c.432-.977 2.583-5.92 2.583-7.42C15.148 6.458 13.73 5 11.99 5c-1.741 0-3.158 1.458-3.158 3.25 0 1.5 2.152 6.443 2.583 7.42a.63.63 0 0 0 .575.38zm.947-7.8a.961.961 0 0 0-.947-.975.961.961 0 0 0-.947.975c0 .539.423.975.947.975a.961.961 0 0 0 .947-.975zm3.78 9.75c.424 0 .818-.218 1.054-.585.235-.367.274-.826.106-1.227l-1.353-3.25a1.26 1.26 0 0 0-1.161-.788h-.541v1.3h.54l1.354 3.25H7.263l1.354-3.25h.52v-1.3h-.52c-.507 0-.963.31-1.16.788l-1.354 3.248a1.33 1.33 0 0 0 .106 1.23c.236.366.63.584 1.054.584h9.453z"
  }));
};

LocationCircle.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var LocationPinLine = function LocationPinLine(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12 12c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3-1.346 3-3 3zm0-4a1.001 1.001 0 1 0 1 1c0-.551-.449-1-1-1z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12 22.667C9.641 19.52 5 12.936 5 9c0-3.86 3.14-7 7-7s7 3.14 7 7c0 3.936-4.641 10.521-7 13.667zM12 4C9.243 4 7 6.243 7 9c0 2.591 3.107 7.583 5 10.291 1.892-2.709 5-7.702 5-10.291 0-2.757-2.243-5-5-5z"
  }));
};

LocationPinLine.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};

var LocationPin = function LocationPin(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12 2a7 7 0 0 0-7 7c0 5 7 13 7 13s7-8 7-13a7 7 0 0 0-7-7zm0 9.5a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5z"
  }));
};

LocationPin.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};

var LocationUserCircle = function LocationUserCircle(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12 24C5.373 24 0 18.627 0 12S5.373 0 12 0s12 5.373 12 12-5.373 12-12 12zm.285-17.917c.315 0 .571.244.571.542 0 .299-.256.542-.571.542-.315 0-.571-.243-.571-.542 0-.298.256-.542.571-.542zm0 2.167c.945 0 1.714-.73 1.714-1.625C14 5.729 13.23 5 12.285 5s-1.714.73-1.714 1.625c0 .896.769 1.625 1.714 1.625zm-.571 6.5v-2.167c0-.299-.256-.541-.572-.541h-.571V11.5c0-.896.769-1.625 1.714-1.625s1.714.73 1.714 1.625v.542h-.571c-.316 0-.572.242-.572.541v2.167h-1.142zm1.714 1.083c.315 0 .571-.242.571-.541v-2.167h.572c.315 0 .571-.243.571-.542V11.5c0-1.493-1.282-2.708-2.857-2.708-1.575 0-2.857 1.215-2.857 2.708v1.083c0 .3.256.542.571.542h.572v2.167c0 .299.256.541.571.541h2.286zM12.285 18c2.752 0 5.714-.678 5.714-2.167 0-.511-.363-1.225-2.09-1.72l-.332 1.036c1.057.303 1.28.632 1.28.684 0 .28-1.572 1.084-4.572 1.084s-4.571-.805-4.571-1.084c0-.055.238-.4 1.369-.71l-.317-1.04c-1.814.496-2.195 1.225-2.195 1.75 0 1.49 2.962 2.167 5.714 2.167z"
  }));
};

LocationUserCircle.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var LocationUser = function LocationUser(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12 6c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3-1.346 3-3 3zm0-4a1.001 1.001 0 1 0 1 1c0-.551-.449-1-1-1zM14 20h-4a1 1 0 0 1-1-1v-4H8a1 1 0 0 1-1-1v-2c0-2.757 2.243-5 5-5s5 2.243 5 5v2a1 1 0 0 1-1 1h-1v4a1 1 0 0 1-1 1zm-3-2h2v-4a1 1 0 0 1 1-1h1v-1c0-1.654-1.346-3-3-3s-3 1.346-3 3v1h1a1 1 0 0 1 1 1v4z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12 24c-4.816 0-10-1.251-10-4 0-.969.667-2.316 3.841-3.232l.555 1.922C4.417 19.261 4 19.898 4 20c0 .515 2.75 2 8 2s8-1.485 8-2c0-.096-.389-.704-2.239-1.264l.58-1.914C21.365 17.738 22 19.056 22 20c0 2.749-5.184 4-10 4z"
  }));
};

LocationUser.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};

var Lock = function Lock(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12 17c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm6-9h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM8.9 6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2H8.9V6zM18 20H6V10h12v10z"
  }));
};

Lock.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var Logout = function Logout(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M18 22H7c-1.103 0-2-.897-2-2v-3h2v3h11V4H7v3H5V4c0-1.102.897-2 2-2h11c1.103 0 2 .898 2 2v16c0 1.103-.897 2-2 2z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.707 7.292l-1.414 1.416L12.59 11H4v2h8.582l-2.29 2.294 1.416 1.412 4.706-4.715z"
  }));
};

Logout.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};

var Manager = function Manager(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M17.077 12.802a6 6 0 1 1-10.154 0L5.024 3.216A1 1 0 0 1 6 2h12a1 1 0 0 1 .976 1.217l-1.899 9.585zm-1.696-1.759L16.753 4H13.8L13 8h-2l-.8-4H7.246l1.373 7.043a5.972 5.972 0 0 1 3.38-1.042c1.255 0 2.42.384 3.382 1.042zM12 20a4 4 0 1 0 0-8 4 4 0 0 0 0 8z",
    fillRule: "nonzero"
  }));
};

Manager.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var MarkUnread = function MarkUnread(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M6 21h15v-7.8l-7 4.7c-.2.1-.3.2-.5.2s-.3-.1-.5-.2l-7-4.7V21zm13.1-9H7.9l5.6 3.8 5.6-3.8zm2-2c1 0 1.9.9 1.9 2v9c0 1.1-.9 2-1.9 2H5.9c-1 0-1.9-.9-1.9-2v-9c0-1.1.9-2 1.9-2h15.2zM1 19V8.5C5.2 5 7.7 2.8 8.7 2 10.2.8 11.8.8 13.3 2c1 .8 3.8 3.2 8.3 7h-3.1c-4.1-3.4-6.2-5.3-6.5-5.5-.4-.4-1.4-.4-1.9 0-.3.2-2.7 2.2-7.1 5.9V19H1z"
  }));
};

MarkUnread.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};

var Medal = function Medal(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M18.78 2.376a1 1 0 0 0-.78-.375H6a1 1 0 0 0-.977 1.217l2 9 1.953-.434-1.73-7.783H10.2l.8 4h2l.8-4h2.954l-1.73 7.783 1.953.434 2-9a1 1 0 0 0-.197-.842z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16 22.001c-.152 0-.306-.035-.447-.105L12 20.119l-3.553 1.776a.998.998 0 0 1-1.072-.114 1.004 1.004 0 0 1-.346-1.022l.893-3.571-1.754-2.632A.998.998 0 0 1 7 13.001h2.382l1.724-3.447c.339-.677 1.45-.677 1.789 0l1.724 3.447H17a1.002 1.002 0 0 1 .832 1.554l-1.754 2.632.893 3.571A1.002 1.002 0 0 1 16 22.001zm-4-4c.153 0 .307.035.447.105l2.055 1.027-.473-1.891a.998.998 0 0 1 .139-.797L15.131 15H14c-.379 0-.725-.214-.895-.553L12 12.237l-1.105 2.211c-.17.339-.516.553-.895.553H8.869l.963 1.445c.156.234.207.523.139.797l-.473 1.891 2.055-1.027a.99.99 0 0 1 .447-.106z"
  }));
};

Medal.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};

var Mention = function Mention(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    className: "st2",
    d: "M10 12.6c-1.4 0-2.6-1.2-2.6-2.6 0-1.4 1.2-2.6 2.6-2.6s2.6 1.2 2.6 2.6c0 1.4-1.2 2.6-2.6 2.6M10 0C4.5 0 0 4.5 0 10s4.5 10 10 10c2 0 4-.6 5.7-1.7l-1.1-1.6c-1.4.8-3 1.3-4.6 1.3-4.4 0-8-3.6-8-8s3.6-8 8-8 8 3.6 8 8v.8c0 1.4-.6 2.2-1.6 2.2H16c-.6 0-1.4-.8-1.4-1.4V10c0-2.5-2.1-4.6-4.6-4.6S5.4 7.5 5.4 10c0 2.5 2.1 4.6 4.6 4.6 1.2 0 2.4-.5 3.2-1.3.6 1 1.8 1.7 2.8 1.7h.4c2.2 0 3.6-1.7 3.6-4.2V10c0-5.5-4.5-10-10-10"
  }));
};

Mention.defaultProps = {
  viewBox: "-1 -1 23 23",
  xmlns: "http://www.w3.org/2000/svg"
};

var Minus = function Minus(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M3 11.001h18v2H3z"
  }));
};

Minus.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};

var MobilePhoneCheck = function MobilePhoneCheck(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M18 23.414l-3.707-3.707 1.414-1.414L18 20.586l4.293-4.293 1.414 1.414zM10 0H2C.897 0 0 .896 0 2v16c0 1.104.897 2 2 2h8c1.103 0 2-.896 2-2V2c0-1.104-.897-2-2-2zm0 2v2H2V2h8zm0 4v8H2V6h8zM2 18v-2h8.001v2H2z"
  }));
};

MobilePhoneCheck.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};

var MobilePhoneClose = function MobilePhoneClose(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M23.707 17.707l-1.414-1.414L20 18.586l-2.293-2.293-1.414 1.414L18.586 20l-2.293 2.293 1.414 1.414L20 21.414l2.293 2.293 1.414-1.414L21.414 20zM10 0H2C.897 0 0 .896 0 2v16c0 1.104.897 2 2 2h8c1.103 0 2-.896 2-2V2c0-1.104-.897-2-2-2zm0 2v2H2V2h8zm0 4v8H2V6h8zM2 18v-2h8.001v2H2z"
  }));
};

MobilePhoneClose.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};

var MobilePhoneQuestionMark = function MobilePhoneQuestionMark(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10 0H2C.897 0 0 .896 0 2v16c0 1.104.897 2 2 2h8c1.103 0 2-.896 2-2V2c0-1.104-.897-2-2-2zm0 2v2H2V2h8zm0 4v8H2V6h8zM2 18v-2h8.001v2H2zM21 21h-2v-3h1c1.103 0 2-.896 2-2s-.897-2-2-2-2 .896-2 2h-2c0-2.205 1.794-4 4-4s4 1.795 4 4a4.007 4.007 0 0 1-3 3.873V21z"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "20",
    cy: "23",
    r: "1"
  }));
};

MobilePhoneQuestionMark.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};

var MobilePhoneView = function MobilePhoneView(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M9 17.999H2v-2h7v-2H2v-8h8v3h2v-7c0-1.104-.897-2-2-2H2c-1.103 0-2 .896-2 2v16c0 1.104.897 2 2 2h7v-2zm-7-16h8v2H2v-2zM23.414 21.999l-3.247-3.247c.524-.79.833-1.735.833-2.753 0-2.757-2.243-5-5-5s-5 2.243-5 5 2.243 5 5 5a4.966 4.966 0 0 0 2.753-.833L22 23.413l1.414-1.414zm-10.414-6c0-1.654 1.346-3 3-3s3 1.346 3 3-1.346 3-3 3-3-1.346-3-3z"
  }));
};

MobilePhoneView.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};

var MobilePhone = function MobilePhone(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M15.999 1.999h-8c-1.103 0-2 .896-2 2v16c0 1.104.897 2 2 2h8c1.103 0 2-.896 2-2v-16c0-1.103-.897-2-2-2zm0 2v2h-8v-2h8zm.001 4v8H7.999v-8H16zm-8.001 12v-2H16v2H7.999z"
  }));
};

MobilePhone.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};

var More = function More(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "12",
    cy: "5.002",
    r: "2"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "12",
    cy: "12.002",
    r: "2"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "12",
    cy: "19.001",
    r: "2"
  })));
};

More.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};

var Notepad = function Notepad(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M7 13h10v2H7zM7 9h8v2H7zM7 17h10v2H7z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M19 2h-2V1a1 1 0 0 0-2 0v1h-2V1a1 1 0 0 0-2 0v1H9V1a1 1 0 0 0-2 0v1H5c-1.103 0-2 .896-2 2v18c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2V4c0-1.104-.897-2-2-2zM5 22V4h2v1a1 1 0 1 0 2 0V4h2v1a1 1 0 1 0 2 0V4h2v1a1 1 0 1 0 2 0V4h2l.001 18H5z"
  })));
};

Notepad.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};

var Offers = function Offers(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M9.388 8.078a4.781 4.781 0 1 1 4.781 8.281 4.781 4.781 0 0 1-4.781-8.28zm4.25.92a3.719 3.719 0 0 0-3.719 0l-.147.09a3.719 3.719 0 1 0 3.866-.09zm-1.682.033c.358 0 .655.2.702.46l.006.072h.177a.531.531 0 0 1 .072 1.057l-.072.005h-.885l-.016-.001-.54.001a.419.419 0 0 0-.215.779l.06.029 1.462.585a1.482 1.482 0 0 1-.042 2.766v.091c0 .293-.318.531-.71.531-.358 0-.654-.2-.701-.459l-.007-.072h-.53a.531.531 0 0 1-.073-1.058l.072-.005h1.438a.42.42 0 0 0 .216-.778l-.06-.03-1.46-.584a1.481 1.481 0 0 1 .397-2.85v-.008c0-.293.318-.53.709-.53zM12.84 0c.844 0 1.534.655 1.59 1.485l.004.109v3.81c0 .422-.168.827-.467 1.126a.531.531 0 0 1-.802-.691l.05-.06a.531.531 0 0 0 .15-.292l.006-.083v-3.81c0-.27-.2-.491-.459-.527l-.072-.004h-3.81a.532.532 0 0 0-.311.1l-.064.055-7.438 7.437a.531.531 0 0 0-.054.688l.054.064 3.81 3.81a.531.531 0 0 0 .692.05l.12-.102a.531.531 0 0 1 .69.803 1.594 1.594 0 0 1-2.161.085l-.092-.085-3.81-3.81a1.594 1.594 0 0 1-.095-2.15l.095-.104L7.905.466c.265-.265.615-.427.987-.46L9.032 0h3.81zm-1.594 2.39l.087.005a.797.797 0 1 1-.173 0l.086-.004z",
    fillRule: "nonzero"
  }));
};

Offers.defaultProps = {
  viewBox: "0 0 17 17",
  xmlns: "http://www.w3.org/2000/svg"
};

var OpenEnvelope = function OpenEnvelope(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M20 11.824l-6.908 4.499a2 2 0 0 1-2.182 0L4 11.823v8.156h16v-8.155zm-.673-1.949l-6.682-5.64a1 1 0 0 0-1.29 0l-6.682 5.64 7.328 4.772 7.326-4.772zm-9.262-7.168a3 3 0 0 1 3.87 0L22 9.515v10.464a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9.515l8.065-6.808z"
  }));
};

OpenEnvelope.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var Paperclip = function Paperclip(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11 23c-2.897 0-5-2.313-5-5.5V9c0-3.991 2.794-7 6.5-7S19 5.009 19 9v7h-2V9c0-2.897-1.893-5-4.5-5S8 6.103 8 9v8.5c0 1.743.928 3.5 3 3.5s3-1.757 3-3.5V10c0-.602-.146-2-1.5-2S11 9.398 11 10v7H9v-7c0-2.393 1.407-4 3.5-4S16 7.607 16 10v7.5c0 3.187-2.103 5.5-5 5.5z"
  }));
};

Paperclip.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};

var Payments = function Payments(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12 24C5.373 24 0 18.627 0 12S5.373 0 12 0s12 5.373 12 12-5.373 12-12 12zm0-2.057c5.491 0 9.943-4.452 9.943-9.943S17.49 2.057 12 2.057 2.057 6.51 2.057 12 6.51 21.943 12 21.943zm-.737-13.071c-.181.216-.272.494-.272.824 0 .34.09.608.295.814.192.206.566.422 1.099.638 1.246.484 2.164.969 2.754 1.453.589.484.884 1.174.884 2.07 0 .855-.295 1.545-.884 2.06-.499.443-1.156.732-1.95.866v1.236c0 .165-.147.298-.328.298h-1.156c-.181 0-.329-.133-.329-.298v-1.205c-.997-.104-1.824-.433-2.493-.98-.611-.514-.951-1.235-.997-2.162-.011-.186.159-.35.374-.35l1.927-.031c.192-.01.374.123.385.298.045.443.181.783.42 1 .294.267.668.401 1.132.401.386 0 .68-.103.884-.309.193-.206.295-.474.295-.803 0-.381-.102-.68-.306-.896-.204-.217-.567-.423-1.088-.629-1.27-.463-2.198-.927-2.776-1.4-.578-.475-.873-1.165-.873-2.081 0-.835.306-1.515.918-2.05.567-.484 1.292-.794 2.187-.907V5.442c0-.165.147-.3.329-.3h1.178c.182 0 .329.135.329.3V6.76c.838.155 1.518.505 2.028 1.04.488.526.76 1.164.816 1.937.012.196-.158.36-.374.36l-1.938.031c-.192 0-.373-.123-.385-.298-.034-.381-.147-.68-.328-.886-.227-.258-.533-.392-.907-.392-.385 0-.669.103-.85.32z"
  }));
};

Payments.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var PaymentsLogo = function PaymentsLogo(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M2.545 12.973h1.493v2.769l.63-.643 1.817-1.835c.256-.262.604-.29.741-.29h5.586c2.864 0 5.283-2.62 5.283-5.721s-2.42-5.721-5.283-5.721H6.689L6.12.007h6.692c1.82 0 3.531.774 4.82 2.18a7.474 7.474 0 0 1 1.956 5.066 7.472 7.472 0 0 1-1.957 5.064c-1.289 1.407-3 2.181-4.819 2.181H7.386L5.72 16.18l-1.407 1.437c-.246.251-.534.383-.815.383a.89.89 0 0 1-.348-.07c-.379-.161-.605-.557-.605-1.06v-3.897zm1.531-3.78c.82-.163 1.126-.609 1.126-1.097 0-.604-.553-.992-1.126-1.168v2.265zM1.474 4.038c0 .603.554.992 1.126 1.167V2.941c-.82.162-1.126.608-1.126 1.097zM4.076 2.94v2.51c1.894.351 2.6 1.474 2.6 2.69 0 1.09-.738 2.267-2.6 2.524v.599a.737.737 0 0 1-1.476 0v-.59C.684 10.43 0 9.157 0 8.138l1.472.002c0 .366.265.868 1.128 1.05V6.683C.707 6.33 0 5.208 0 3.993c0-1.091.738-2.268 2.6-2.525V.87a.737.737 0 0 1 1.476 0v.587c1.916.228 2.6 1.416 2.6 2.435H5.204c0-.361-.316-.789-1.128-.95z",
    fillRule: "evenodd"
  }));
};

PaymentsLogo.defaultProps = {
  viewBox: "0 0 20 18",
  xmlns: "http://www.w3.org/2000/svg"
};

var PencilSmall = function PencilSmall(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M20.28 8.155l.801-.801a3.14 3.14 0 0 0 0-4.436c-1.185-1.184-3.25-1.185-4.436 0l-.808.808 4.443 4.429zM18.858 9.575l-9.109 9.109c-.078.077-.164.14-.26.188l-6.043 3.022a1 1 0 0 1-1.341-1.342l3.02-6.043c.049-.096.112-.182.188-.26l9.109-9.109 4.436 4.435z"
  })));
};

PencilSmall.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};

var PencilWrite = function PencilWrite(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M18 22H4c-1.103 0-2-.897-2-2V6c0-1.102.897-2 2-2h7v2H4v14h14v-9h2v9c0 1.103-.897 2-2 2z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M9.808 10.365l2.828 2.827-3.535.707zM20.414 5.414a2 2 0 1 0-2.828-2.828L11.222 8.95l2.829 2.829 6.363-6.365z"
  }));
};

PencilWrite.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};

var Pencil = function Pencil(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M20.821 3.18a4 4 0 0 0-2.847-1.178 3.997 3.997 0 0 0-2.846 1.179L3.72 14.59a.995.995 0 0 0-.263.464L2.03 20.759a1 1 0 0 0 1.213 1.212l5.705-1.427a.995.995 0 0 0 .464-.263L20.82 8.872a4.005 4.005 0 0 0 1.179-2.846 3.996 3.996 0 0 0-1.179-2.847l.001.001zM9.077 16.338l7.471-7.471.727.725-7.955 7.955-.243-1.209zm-1.414-1.415l-1.209-.241 7.956-7.955.725.726-7.472 7.47zm-2.497 1.541l1.976.395.396 1.977-3.163.791.791-3.163zM15.823 5.313l.72-.718c.766-.764 2.1-.764 2.864 0l-.002-.001c.765.765.765 2.099 0 2.864l-.718.72-2.864-2.865z"
  }));
};

Pencil.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};

var Pending = function Pending(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M5.833 4.777a10.006 10.006 0 0 1 10.75-2.014.712.712 0 0 1 .24.164 9.952 9.952 0 0 1 3.106 2.2c3.81 3.98 3.67 10.296-.31 14.105a9.975 9.975 0 0 1-10.73 2.002.715.715 0 1 1 .549-1.32 8.548 8.548 0 1 0-5.062-6.044l.03.13a8.523 8.523 0 0 0 1.184 2.735V14.14a.715.715 0 0 1 1.427-.056l.002.056v4.288c0 .375-.29.684-.658.712l-.056.002h-.21a.719.719 0 0 1-.118 0h-3.96a.715.715 0 0 1-.056-1.427l.056-.002h2.51a9.91 9.91 0 0 1-1.4-2.95l-.062-.233a10.005 10.005 0 0 1 2.768-9.754z",
    fillRule: "nonzero"
  }));
};

Pending.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var PictureLayerSolid = function PictureLayerSolid(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M17 7.001v-1a2 2 0 0 0-2-2H3a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h2V9a2 2 0 0 1 2-2h10z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M21 9H9a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2zM9 19l2.828-4.537 2.022 3.244 3.173-5.088L21 19H9z"
  })));
};

PictureLayerSolid.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};

var PictureLayer = function PictureLayer(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M21 8.999H9a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2zm0 10H9v-8h12v8z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M3 5.999h12v1h2v-1a2 2 0 0 0-2-2H3a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h2v-2H3v-8zM16.646 12.619l-2.641 4.235-1.146-1.838L11 17.999h9z"
  })));
};

PictureLayer.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};

var Play = function Play(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12 20.292c4.572 0 8.292-3.72 8.292-8.292 0-4.572-3.72-8.292-8.292-8.292-4.572 0-8.292 3.72-8.292 8.292 0 4.572 3.72 8.292 8.292 8.292zM1.635 12C1.635 6.284 6.285 1.635 12 1.635c5.716 0 10.365 4.65 10.365 10.365 0 5.717-4.65 10.365-10.365 10.365-5.716 0-10.365-4.648-10.365-10.365zm8.292 4.146V7.854L16.147 12l-6.22 4.146z"
  }));
};

Play.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var PlusCircleSolid = function PlusCircleSolid(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12 2.001c-5.514 0-10 4.486-10 10s4.486 10 10 10 10-4.486 10-10-4.486-10-10-10zm5 11h-4v4h-2v-4H7v-2h4v-4h2v4h4v2z"
  }));
};

PlusCircleSolid.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};

var PlusCircle = function PlusCircle(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12 2.001c-5.514 0-10 4.486-10 10s4.486 10 10 10 10-4.486 10-10-4.486-10-10-10zm0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M13 7.001h-2v4H7v2h4v4h2v-4h4v-2h-4z"
  })));
};

PlusCircle.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};

var Plus = function Plus(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M21 11.001h-8v-8h-2v8H3v2h8v8h2v-8h8z"
  }));
};

Plus.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};

var PodiumIcon = function PodiumIcon(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M3.285 4h10.417c3.777 0 6.778 3.335 6.778 7.18 0 3.846-3.003 7.181-6.778 7.181H7.424c-.079 0-.189.022-.244.078l-2.04 2.029-1.585 1.595c-.305.308-.555.204-.555-.23V4.238C3 4.081 3.128 4 3.285 4zM15.13 8.745V7.686a.144.144 0 0 0-.143-.144H6.71a.144.144 0 0 0-.143.144v1.06c0 .078.065.143.143.143h8.276a.144.144 0 0 0 .143-.144zm1.784 2.917v-1.058a.144.144 0 0 0-.143-.144H6.746a.144.144 0 0 0-.143.144v1.058c0 .079.064.143.143.143H16.77a.144.144 0 0 0 .143-.143zm-1.784 2.918v-1.06a.144.144 0 0 0-.143-.143H6.71a.144.144 0 0 0-.143.143v1.06c0 .079.065.143.143.143h8.276a.144.144 0 0 0 .143-.143z"
  }));
};

PodiumIcon.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var PossibleIntegrations = function PossibleIntegrations(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M15.284 12.63a.54.54 0 0 1-.96-.496l.901-1.739a1.1 1.1 0 0 0-1.952-1.012l-.9 1.739a.54.54 0 0 1-.96-.497l.901-1.74a2.18 2.18 0 1 1 3.87 2.007l-.9 1.739zm-5.214.229a.54.54 0 0 1 .959.497l-.9 1.737a1.099 1.099 0 1 0 1.951 1.013l.901-1.739a.54.54 0 0 1 .959.497l-.901 1.739a2.18 2.18 0 0 1-3.87-2.007l.9-1.737zm2.892-1.822a.54.54 0 1 1 .959.497l-1.549 2.987a.54.54 0 1 1-.959-.497l1.549-2.987zm7.326 1.463a7.788 7.788 0 1 0-15.576 0 7.788 7.788 0 0 0 15.576 0zm1.424 0a9.213 9.213 0 1 1-18.426-.002 9.213 9.213 0 0 1 18.426.002z"
  }));
};

PossibleIntegrations.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var QuestionSolid = function QuestionSolid(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z"
  }));
};

QuestionSolid.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};

var Question = function Question(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12 22C6.486 22 2 17.515 2 12 2 6.487 6.486 2 12 2s10 4.486 10 10c0 5.515-4.486 10-10 10zm0-18c-4.411 0-8 3.589-8 8s3.589 8 8 8 8-3.589 8-8-3.589-8-8-8z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M13 15h-2v-3h1a2 2 0 1 0-2-2H8c0-2.205 1.795-4 4-4s4 1.795 4 4a4.011 4.011 0 0 1-3 3.875V15z"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "12",
    cy: "17",
    r: "1.25"
  }));
};

Question.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};

var Receipt = function Receipt(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M19.525 1.15a.998.998 0 0 0-.973-.044l-3.48 1.74-2.518-1.678a1 1 0 0 0-1.109 0L8.928 2.846l-3.48-1.74A.998.998 0 0 0 4 2v20a1.001 1.001 0 0 0 1.448.895l3.48-1.74 2.518 1.677a.995.995 0 0 0 1.109 0l2.517-1.677 3.481 1.74A.998.998 0 0 0 20 22V2a.998.998 0 0 0-.475-.85zM18 20.382l-2.553-1.276a.999.999 0 0 0-1.002.062L12 20.798l-2.445-1.63a1.004 1.004 0 0 0-1.002-.062L6 20.382V3.619l2.553 1.275a1 1 0 0 0 1.002-.063L12 3.202l2.445 1.629c.298.2.681.223 1.002.063L18 3.619v16.763z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M13 7h-2v1.051c-1.14.232-2 1.242-2 2.449 0 1.378 1.121 2.5 2.5 2.5h1c.275 0 .5.225.5.5s-.225.5-.5.5H9v2h2v1h2v-1.051c1.14-.232 2-1.243 2-2.449 0-1.378-1.121-2.5-2.5-2.5h-1a.501.501 0 0 1-.5-.5c0-.275.225-.5.5-.5H15V8h-2V7z"
  }));
};

Receipt.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};

var Refund = function Refund(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M15.427 8.486H7.751l3.347-3.347-2.366-2.367-7.389 7.388 7.389 7.389 2.366-2.367-3.347-3.348h7.676a3.352 3.352 0 0 1 3.348 3.348 3.351 3.351 0 0 1-3.348 3.348h-1.674v3.347h1.674a6.702 6.702 0 0 0 6.696-6.695 6.702 6.702 0 0 0-6.696-6.696z",
    fillRule: "evenodd"
  }));
};

Refund.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var Salesforce = function Salesforce(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16.92 15.902c.266.045.539.068.817.068 2.719 0 4.923-2.233 4.923-4.988 0-2.754-2.204-4.987-4.923-4.987-.487 0-.957.072-1.402.205a3.933 3.933 0 0 0-3.52-2.2 3.91 3.91 0 0 0-3.043 1.456A4.232 4.232 0 0 0 6.58 4C4.223 4 2.313 5.935 2.313 8.322c0 .615.126 1.199.354 1.728A4 4 0 0 0 1 13.31c0 2.204 1.763 3.99 3.938 3.99.075 0 .149-.002.222-.006.539 1.553 2 2.666 3.716 2.666 1.521 0 2.84-.873 3.497-2.152.348.102.717.157 1.098.157a3.93 3.93 0 0 0 3.45-2.063z"
  }));
};

Salesforce.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var Search = function Search(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M15.5 14h-.79l-.28-.27A6.471 6.471 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
  }));
};

Search.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};

var Send = function Send(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M9.9 16.3C5.9 18 3.8 19 3 19.1L6.7 13h10.5c-3 1.3-5.4 2.4-7.3 3.3zM3.1 4.9C3.9 5.1 6 6 9.9 7.8c1.9.9 4.3 1.9 7.3 3.2H6.7L3.1 4.9zm19.3 6.2c-5.2-2.2-8.9-3.9-11.7-5.2-5.4-2.4-6.8-3-7.8-3-.9 0-1.3.5-1.5.7-.5.6-.5 1.6-.1 2.3L5 12l-3.7 6.1c-.4.7-.4 1.6.2 2.3.1.2.6.7 1.4.7 1 0 2.4-.6 7.8-3 2.8-1.2 6.5-2.9 11.7-5.2.4-.2.6-.5.6-.9s-.2-.8-.6-.9z"
  }));
};

Send.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};

var Share = function Share(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11 6.415v9.586h2V6.415l3.293 3.293 1.414-1.414L12 2.587 6.293 8.294l1.414 1.414zM18 18.001v2H6v-2H4v2c0 1.102.897 2 2 2h12c1.104 0 2-.898 2-2v-2h-2z"
  })));
};

Share.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};

var ShieldChecked = function ShieldChecked(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.931 20.995c.91-.546 2.694-1.733 4.263-3.206.784-.737 1.535-1.564 2.095-2.437.556-.866.961-1.838.961-2.848v-7c0-.495-.213-.95-.557-1.27a1.81 1.81 0 0 0-1.232-.48H5.539c-.898 0-1.788.698-1.788 1.75v7c0 1.01.405 1.982.961 2.848.56.873 1.31 1.7 2.095 2.437 1.57 1.473 3.355 2.66 4.263 3.207l.452.246a1 1 0 0 0 .958 0l.453-.247zm-5.27-4.117c1.484 1.392 3.19 2.528 4.052 3.046l.002.001a.556.556 0 0 0 .57 0h.002c.862-.519 2.568-1.655 4.051-3.047.741-.696 1.414-1.444 1.899-2.2.486-.76.763-1.495.763-2.174v-7a.483.483 0 0 0-.158-.354.56.56 0 0 0-.38-.146H5.538c-.297 0-.538.224-.538.5v7c0 .68.277 1.415.763 2.174.485.756 1.158 1.504 1.899 2.2z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.459 8.01c.27.214.317.607.103.877l-4.619 5.847a1.244 1.244 0 0 1-2.014-.06l-1.44-2.046a.625.625 0 1 1 1.022-.72l1.447 2.056.001-.002 4.622-5.85a.625.625 0 0 1 .878-.102z"
  }));
};

ShieldChecked.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var ShieldX = function ShieldX(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M15.236 8.018a.687.687 0 0 1 0 .972l-2.264 2.264 2.264 2.264a.687.687 0 1 1-.972.972L12 12.226 9.736 14.49a.687.687 0 0 1-.972-.972l2.264-2.264L8.764 8.99a.688.688 0 0 1 .972-.972L12 10.282l2.264-2.264a.687.687 0 0 1 .972 0z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.931 20.995c.91-.546 2.694-1.733 4.263-3.206.784-.737 1.535-1.564 2.095-2.437.556-.866.961-1.838.961-2.848v-7c0-.495-.213-.95-.557-1.27a1.81 1.81 0 0 0-1.232-.48H5.539c-.898 0-1.788.698-1.788 1.75v7c0 1.01.405 1.982.961 2.848.56.873 1.31 1.7 2.095 2.437 1.57 1.473 3.355 2.66 4.263 3.207l.452.246a1 1 0 0 0 .958 0l.453-.247zm-5.27-4.117c1.484 1.392 3.19 2.528 4.052 3.046l.002.001a.556.556 0 0 0 .57 0h.002c.862-.519 2.568-1.655 4.051-3.047.741-.696 1.414-1.444 1.899-2.2.486-.76.763-1.495.763-2.174v-7a.483.483 0 0 0-.158-.354.56.56 0 0 0-.38-.146H5.538c-.297 0-.538.224-.538.5v7c0 .68.277 1.415.763 2.174.485.756 1.158 1.504 1.899 2.2z"
  }));
};

ShieldX.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var SkyhookLogo = function SkyhookLogo(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M19.12 3.06H4.88A1.92 1.92 0 0 0 3 5v8.68a1.91 1.91 0 0 0 1.91 1.9h3.21l.11 1a.77.77 0 0 0 0 .15v.33l.4 3.4a.61.61 0 0 0 .6.53h.07a.59.59 0 0 0 .52-.66l-.05-.45.09-.06.44-.44 1.21 1.21a.6.6 0 0 0 .43.18.64.64 0 0 0 .23-.05.49.49 0 0 0 .2-.13l1.21-1.21.51.51-.05.43a.59.59 0 0 0 .52.66h.07a.61.61 0 0 0 .6-.53l.57-4.85h3.24A1.91 1.91 0 0 0 21 13.65V5a1.92 1.92 0 0 0-1.88-1.94zM9 12.92h1.7l.45.46-.88.88L9 13zm6 .08l-1.25 1.25-.88-.88.45-.46H15zm-5.57 2.1l-.14.14v-.31zm.05 1.64l.79-.79.88.88-.79.79zm1.64-1.64l.88-.87.88.87-.88.9zm2.61.85l.79.79-.88.88-.79-.79zm1-.71l-.14-.14.18-.17zm.54-3.53H8.75V8.26h6.5zM12 19.26l-.79-.79.79-.79.79.79zm7.83-5.61a.71.71 0 0 1-.71.7H16l.17-1.44h1.22a.6.6 0 0 0 0-1.2h-1V7.85a.79.79 0 0 0-.79-.79H8.34a.79.79 0 0 0-.79.79v3.86h-1a.6.6 0 1 0 0 1.2h1.26L8 14.35H4.88a.71.71 0 0 1-.71-.7V5a.7.7 0 0 1 .71-.7h14.24a.7.7 0 0 1 .71.7z"
  }));
};

SkyhookLogo.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};

var StarAdd = function StarAdd(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M19.615 9.761l-2.696-.362-4.101-.617-1.84-3.693-1.851 3.72-4.142.598 2.997 2.896-.708 4.09 3.695-1.926V17.3l-4.787 2.495a1.27 1.27 0 0 1-1.708-.527 1.245 1.245 0 0 1-.128-.796l.917-5.294-3.88-3.75a1.247 1.247 0 0 1-.024-1.774 1.27 1.27 0 0 1 .724-.366l5.363-.772L9.844 1.7a1.27 1.27 0 0 1 2.27 0l2.398 4.817 5.362.772c.692.1 1.171.736 1.07 1.422-.04.273-.556 1.148-1.33 1.05zm-.411 5.967h2.53A1.26 1.26 0 0 1 23 16.982a1.26 1.26 0 0 1-1.265 1.255h-2.531v2.509A1.26 1.26 0 0 1 17.938 22a1.26 1.26 0 0 1-1.265-1.254v-2.51h-2.53a1.26 1.26 0 0 1-1.266-1.254 1.26 1.26 0 0 1 1.265-1.254h2.531v-2.509a1.26 1.26 0 0 1 1.265-1.254 1.26 1.26 0 0 1 1.266 1.254v2.509z",
    fillRule: "nonzero"
  }));
};

StarAdd.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var StarCrossed = function StarCrossed(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M18 17.3l.7 2.6c.1.4 0 .8-.4 1.1-.2.1-.4.2-.6.2-.2 0-.4-.1-.6-.2l-5.4-3.6L6.3 21c-.3.2-.8.2-1.1 0-.3-.2-.5-.7-.4-1.1L6.5 14c.1-.5.5-.8 1-.8.6 0 1 .4 1 1v.2l-.1.2-.9 3.2 3.7-2.5c.2-.1.4-.2.6-.2.2 0 .4.1.6.2l3.7 2.5v-.2c0-.6.4-1 1-1 .4 0 .8.3.9.7zM9.7 9.4l-.3.3 6.4 2.7 2.5-2.5h-3.6c-.4 0-.7-.2-.9-.6l-2.1-4.2-2 4.3zm12.7 5.8c.5.2.7.8.5 1.3-.2.5-.8.7-1.3.5l-20-8.5c-.5-.1-.7-.7-.5-1.2.2-.5.8-.7 1.3-.5L5.3 8h2.9l2.7-5.4c.3-.7 1.5-.7 1.8 0L15.4 8h5.4c.4 0 .8.2.9.6.2.4.1.8-.2 1.1l-3.6 3.6 4.5 1.9z"
  }));
};

StarCrossed.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};

var StarLine = function StarLine(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M18 22.001a1 1 0 0 1-.555-.168L12 18.203l-5.445 3.63a1 1 0 0 1-1.516-1.106l1.838-6.435-4.584-4.584A1.001 1.001 0 0 1 3 8.001h5.382l2.724-5.447c.339-.677 1.45-.677 1.789 0l2.724 5.447H21a1 1 0 0 1 .707 1.707l-4.584 4.584 1.838 6.435A1 1 0 0 1 18 22.001zm-6-6c.193 0 .387.057.555.168l3.736 2.491-1.252-4.384a.996.996 0 0 1 .254-.982l3.293-3.293H15c-.379 0-.725-.214-.895-.553L12 5.237 9.895 9.448c-.17.339-.516.553-.895.553H5.414l3.293 3.293a1 1 0 0 1 .254.982L7.709 18.66l3.736-2.491c.168-.111.362-.168.555-.168z"
  }));
};

StarLine.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};

var Star = function Star(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M21.924 8.618A1 1 0 0 0 21 8.001h-5.382l-2.724-5.447c-.339-.677-1.45-.677-1.789 0L8.382 8.001H3a1 1 0 0 0-.707 1.707l4.584 4.584-1.838 6.435a1 1 0 0 0 1.515 1.106L12 18.203l5.445 3.63a.998.998 0 0 0 1.516-1.106l-1.838-6.435 4.584-4.584c.286-.285.371-.717.217-1.09z"
  }));
};

Star.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};

var Store = function Store(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M22.937 10.649l-3-8A1.002 1.002 0 0 0 19 2H5c-.417 0-.79.259-.937.649l-3 8c-.114.307-.072.651.114.92.188.27.495.431.823.431h1v9a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-9h1a1 1 0 0 0 .937-1.351zM20.557 10h-2.775l-1.5-6h2.025l2.25 6zM8.281 10l1.5-6H11v6H8.281zM13 4h1.219l1.5 6H13V4zM5.693 4h2.025l-1.5 6H3.443l2.25-6zM14 20v-5h2v5h-2zm5 0h-1v-6a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v6H5v-8h14v8z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M7 18h3a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1z"
  }));
};

Store.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};

var Table = function Table(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M21 2H3a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1zm-1 2v3H4V4h16zm-7 5h7v4h-7V9zm-2 4H4V9h7v4zm-7 2h7v5H4v-5zm9 5v-5h7v5h-7z"
  }));
};

Table.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};

var Tag = function Tag(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M21.707 13.293l-11-11A.997.997 0 0 0 10 2H3a1 1 0 0 0-1 1v7c0 .266.105.519.293.707l11 11a.997.997 0 0 0 1.414 0l7-7a.999.999 0 0 0 0-1.414zM7 9a2 2 0 1 1-.001-3.999A2 2 0 0 1 7 9z"
  }));
};

Tag.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};

var Teamchat = function Teamchat(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-1",
    d: "M135.79 15.51A47.67 47.67 0 0 0 100.78 0H33.46a7 7 0 0 0-7.26 7v11H37v-7.16h63.74c20.8 0 38.38 18.64 38.38 40.69s-17.58 40.68-38.38 40.68H60.2a7.76 7.76 0 0 0-5.38 2.07l-25.33 24.85a4.91 4.91 0 0 0-.28 6.72l.35.41a4.77 4.77 0 0 0 3.53 1.7 8.51 8.51 0 0 0 5.91-2.72L49.26 115l12.1-12h39.42a47.65 47.65 0 0 0 35-15.51 52.74 52.74 0 0 0 0-72zM20.67 59.78h.15l-.17-.06z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-1",
    d: "M70.28 81.11a10.6 10.6 0 0 0 10.59-10.59V37.71a10.6 10.6 0 0 0-10.59-10.59H10.59A10.6 10.6 0 0 0 0 37.71v32.81a10.6 10.6 0 0 0 10.59 10.59H17V96a5.84 5.84 0 0 0 3.52 5.36 5.92 5.92 0 0 0 2.32.48 5.81 5.81 0 0 0 4-1.58l19.63-19.15zm-41.75 1.37V69.56h-17V38.67h57.8v30.89H41.77z"
  }))));
};

Teamchat.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 150 127.96"
};

var Trash = function Trash(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M5 20c0 1.103.897 2 2 2h10c1.103 0 2-.897 2-2V8H5v12zm2-10h10l.001 10H7V10zM15 5V3H9v2H3v2h18V5z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M9 12h2v6H9zM13 12h2v6h-2z"
  })));
};

Trash.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};

var TrendingDown = function TrendingDown(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16 18l2.29-2.29-4.88-4.88-4 4L2 7.41 3.41 6l6 6 4-4 6.3 6.29L22 12v6z"
  }));
};

TrendingDown.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};

var TrendingUp = function TrendingUp(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16 6l2.29 2.29-4.88 4.88-4-4L2 16.59 3.41 18l6-6 4 4 6.3-6.29L22 12V6z"
  }));
};

TrendingUp.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};

var UserChat = function UserChat(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M15.001 16a1 1 0 0 1-1-1v-2h-1v-2h2a1 1 0 0 1 1 1v1l2.4-1.8a1 1 0 0 1 .6-.2h3V4h-10v3h-2V4c0-1.103.897-2 2-2h10c1.103 0 2 .897 2 2v7c0 1.102-.897 2-2 2h-2.667l-3.733 2.8c-.177.132-.388.2-.6.2z"
  }), /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M8.001 16c2.205 0 4-1.794 4-4 0-2.205-1.795-4-4-4-2.206 0-4 1.795-4 4 0 2.206 1.794 4 4 4zM8.001 17c-4.711 0-8 2.467-8 6v1h16v-1c0-3.533-3.29-6-8-6z"
  })));
};

UserChat.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};

var UserGroup = function UserGroup(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M20.372 19.059a3.483 3.483 0 0 0 1.129-2.559c0-1.93-1.57-3.5-3.5-3.5s-3.5 1.57-3.5 3.5c0 1.013.439 1.918 1.129 2.559-1.478.534-2.629 1.562-2.629 2.941h2c0-.598 1.413-1.357 3-1.357s3 .76 3 1.357h2c0-1.38-1.151-2.407-2.629-2.941zM18.001 15c.827 0 1.5.673 1.5 1.5s-.673 1.5-1.5 1.5-1.5-.673-1.5-1.5.673-1.5 1.5-1.5zM8.372 19.059A3.483 3.483 0 0 0 9.501 16.5c0-1.93-1.57-3.5-3.5-3.5s-3.5 1.57-3.5 3.5c0 1.013.439 1.918 1.129 2.559-1.478.534-2.629 1.561-2.629 2.941h2c0-.598 1.413-1.357 3-1.357s3 .76 3 1.357h2c0-1.38-1.151-2.407-2.629-2.941zM6.001 15c.827 0 1.5.673 1.5 1.5s-.673 1.5-1.5 1.5-1.5-.673-1.5-1.5.673-1.5 1.5-1.5zM15.001 11h2c0-1.38-1.151-2.407-2.629-2.941A3.483 3.483 0 0 0 15.501 5.5c0-1.93-1.57-3.5-3.5-3.5s-3.5 1.57-3.5 3.5c0 1.013.439 1.918 1.129 2.559C8.152 8.593 7.001 9.62 7.001 11h2c0-.598 1.413-1.357 3-1.357s3 .759 3 1.357zm-3-7c.827 0 1.5.673 1.5 1.5s-.673 1.5-1.5 1.5-1.5-.673-1.5-1.5.673-1.5 1.5-1.5z"
  })));
};

UserGroup.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};

var UserMagnify = function UserMagnify(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M21.657 20.293l-5.363-5.363A7.93 7.93 0 0 0 18.001 10a7.945 7.945 0 0 0-2.344-5.656C14.146 2.832 12.138 2 10.001 2s-4.146.832-5.656 2.344C2.833 5.854 2.001 7.863 2.001 10s.833 4.146 2.344 5.656A7.94 7.94 0 0 0 10.001 18c1.787 0 3.48-.59 4.872-1.664l5.371 5.371 1.413-1.414zM5.759 14.242A5.956 5.956 0 0 1 4.001 10c0-1.604.624-3.109 1.758-4.242C6.892 4.624 8.398 4 10.001 4s3.109.624 4.242 1.759A5.952 5.952 0 0 1 16.001 10a5.956 5.956 0 0 1-1.758 4.242C13.11 15.376 11.604 16 10.001 16s-3.109-.624-4.242-1.758z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M6.95 14c0-1.841 1.159-3 3-3s3 1.159 3 3h-6z"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "9.95",
    cy: "8",
    r: "2"
  })));
};

UserMagnify.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};

var UserPlus = function UserPlus(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M8.002 16.006c2.205 0 4-1.795 4-4s-1.795-4-4-4-4 1.795-4 4 1.795 4 4 4zM8.002 17.006c-4.711 0-8 2.467-8 6v1h16v-1c0-3.533-3.289-6-8-6z"
  })), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M22.002 7.006h-3v-3h-2v3h-3v2h3v3h2v-3h3z"
  }));
};

UserPlus.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};

var UserSolid = function UserSolid(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.002 12.006c2.206 0 4-1.795 4-4s-1.794-4-4-4-4 1.795-4 4 1.795 4 4 4zM12.002 13.006c-4.71 0-8 2.467-8 6v1h16v-1c0-3.533-3.289-6-8-6z"
  })));
};

UserSolid.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};

var User = function User(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.002 12.006c-2.206 0-4-1.794-4-4 0-2.205 1.794-4 4-4s4 1.795 4 4c0 2.206-1.794 4-4 4zm0-6c-1.103 0-2 .896-2 2 0 1.103.897 2 2 2s2-.897 2-2c0-1.104-.897-2-2-2zM20.002 20.006h-16v-1c0-3.533 3.29-6 8-6s8 2.467 8 6v1zm-13.841-2h11.683c-.598-1.808-2.833-3-5.841-3s-5.244 1.192-5.842 3z"
  }));
};

User.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};

var Variables = function Variables(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M4.266 16.945a1.418 1.418 0 0 1-1.433-1.434c0-.809.635-1.452 1.433-1.452.816 0 1.45.643 1.45 1.452 0 .809-.634 1.434-1.45 1.434zM4.266 11.577a1.434 1.434 0 0 1-1.433-1.452c0-.809.635-1.434 1.433-1.434.816 0 1.45.625 1.45 1.434 0 .809-.634 1.452-1.45 1.452zM10.758 17c-1.741 0-3.174-.846-3.174-2.85 0-2.242 2.14-3.05 4.86-3.05h1.179v-.497c0-1.287-.435-1.93-1.723-1.93-1.142 0-1.704.551-1.813 1.507H7.965C8.147 7.938 9.905 7 12.027 7c2.122 0 3.79.882 3.79 3.511v6.305H13.66V15.64c-.616.827-1.45 1.36-2.901 1.36zm.526-1.6c1.342 0 2.339-.716 2.339-1.948v-.956h-1.124c-1.669 0-2.739.386-2.739 1.563 0 .809.436 1.342 1.524 1.342zM19.716 16.945a1.418 1.418 0 0 1-1.433-1.434c0-.809.635-1.452 1.433-1.452.816 0 1.45.643 1.45 1.452 0 .809-.634 1.434-1.45 1.434zM19.716 11.577a1.434 1.434 0 0 1-1.433-1.452c0-.809.635-1.434 1.433-1.434.816 0 1.45.625 1.45 1.434 0 .809-.634 1.452-1.45 1.452z"
  }));
};

Variables.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var Video = function Video(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M20.526 8.148a1 1 0 0 0-.973-.044L17 9.381V7.999c0-1.104-.897-2-2-2H6c-1.103 0-2 .896-2 2v8c0 1.104.897 2 2 2h9c1.103 0 2-.896 2-2v-1.382l2.553 1.276a1.005 1.005 0 0 0 .973-.044 1 1 0 0 0 .474-.85v-6c0-.347-.18-.668-.474-.851zm-5.529 7.851H6v-8h9l-.003 8zM19 13.381l-2-1v-.764l2-1v2.764z"
  }));
};

Video.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};

var Wand = function Wand(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M3.293 19.212L13.9 8.606l1.414 1.414L4.707 20.626zM15.314 7.192l2.829-2.829 1.414 1.414-2.83 2.83zM16.796 12.73l.518-1.932 3.864 1.035-.517 1.932zM14.297 18.714l-1.035-3.865 1.932-.517 1.035 3.865zM12.088 2.741l1.035 3.864-1.932.517-1.035-3.863zM5.723 7.691l3.865 1.036-.518 1.93-3.864-1.035z"
  })));
};

Wand.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};

var Webchat = function Webchat(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M20.936 6.07a7.55 7.55 0 0 1 0 10.214 6.651 6.651 0 0 1-4.9 2.18h-5.531l-1.695 1.69-1.435 1.449c-.213.234-.51.375-.825.392a.77.77 0 0 1-.348-.076 1.09 1.09 0 0 1-.62-1.09v-3.924h1.522v2.79l.64-.654L9.593 17.2c.203-.19.472-.296.75-.294h5.693c3.074-.118 5.489-2.68 5.433-5.766a5.75 5.75 0 0 0-4.64-5.657 7.635 7.635 0 0 0-.945-1.602h.152a6.64 6.64 0 0 1 4.9 2.19zM14.21 3.946a6.555 6.555 0 0 1 0 8.862 5.718 5.718 0 0 1-4.238 1.907H5.376L2.79 17.341a1.15 1.15 0 0 1-.804.37.78.78 0 0 1-.359-.076 1.09 1.09 0 0 1-.608-1.09V3.02a.983.983 0 0 1 1-.992h7.953a5.73 5.73 0 0 1 4.238 1.918zm.141 4.426h-.032A4.627 4.627 0 0 0 9.972 3.64H2.594v11.652l1.848-1.897c.202-.184.466-.285.739-.283h4.824A4.638 4.638 0 0 0 14.35 8.37z",
    fillRule: "nonzero"
  }));
};

Webchat.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var WindowArrow = function WindowArrow(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M21.003 2H2.997C1.893 2.005 1 2.857 1 3.906v15.188c-.003.505.206.99.581 1.347.375.358.885.559 1.416.559h18.006c.531 0 1.04-.201 1.416-.559.375-.358.584-.842.581-1.347V3.906c0-1.049-.893-1.9-1.997-1.906zM21 6h-8V4h8v2zM8 4h3v2H8V4zM6 6H3V4h3v2zM3 19V8h18v11H3z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.6 12.63H7.76v1.94h4.84v2.89l3.86-3.86-3.86-3.87z"
  }));
};

WindowArrow.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var WindowChecked = function WindowChecked(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("style", null, ".___sent-to-crm-green", "{", "fill:#22d85d", "}"), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M21.003 2H2.997C1.893 2.005 1 2.857 1 3.906v15.188c-.003.505.206.99.581 1.347.375.358.885.559 1.416.559h18.006c.531 0 1.04-.201 1.416-.559.375-.358.584-.842.581-1.347V3.906c0-1.049-.893-1.9-1.997-1.906zM21 6h-8V4h8v2zM8 4h3v2H8V4zM6 6H3V4h3v2zM3 19V8h18v11H3z",
    id: "Shape"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "___sent-to-crm-green",
    d: "M10.94 17.58L7 13.63l1.5-1.5 2.44 2.44L15.5 10l1.5 1.5z"
  }));
};

WindowChecked.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};

var XCircle = function XCircle(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12 2.001c-5.514 0-10 4.486-10 10s4.486 10 10 10 10-4.486 10-10-4.486-10-10-10zm4.707 13.293l-1.414 1.414L12 13.415l-3.293 3.293-1.414-1.414 3.293-3.293-3.293-3.293 1.414-1.414L12 10.587l3.293-3.293 1.414 1.414-3.293 3.293 3.293 3.293z"
  }));
};

XCircle.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};

var X = function X(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M20.707 4.707l-1.414-1.414L12 10.586 4.707 3.293 3.293 4.707 10.586 12l-7.293 7.293 1.414 1.414L12 13.414l7.293 7.293 1.414-1.414L13.414 12z"
  }));
};

X.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
var IconAlertBell = (0, _withSize["default"])(AlertBell);
exports.IconAlertBell = IconAlertBell;
var IconAlertBrokenIntegration = (0, _withSize["default"])(AlertBrokenIntegration);
exports.IconAlertBrokenIntegration = IconAlertBrokenIntegration;
var IconAlertCircleSolid = (0, _withSize["default"])(AlertCircleSolid);
exports.IconAlertCircleSolid = IconAlertCircleSolid;
var IconAlertCircle = (0, _withSize["default"])(AlertCircle);
exports.IconAlertCircle = IconAlertCircle;
var IconAlertEmailBounce = (0, _withSize["default"])(AlertEmailBounce);
exports.IconAlertEmailBounce = IconAlertEmailBounce;
var IconAlertNps = (0, _withSize["default"])(AlertNps);
exports.IconAlertNps = IconAlertNps;
var IconAlertReviewInvite = (0, _withSize["default"])(AlertReviewInvite);
exports.IconAlertReviewInvite = IconAlertReviewInvite;
var IconAlertTriangle = (0, _withSize["default"])(AlertTriangle);
exports.IconAlertTriangle = IconAlertTriangle;
var IconArchive = (0, _withSize["default"])(Archive);
exports.IconArchive = IconArchive;
var IconArrow = (0, _withDirection["default"])((0, _withSize["default"])(Arrow));
exports.IconArrow = IconArrow;
var IconBlock = (0, _withSize["default"])(Block);
exports.IconBlock = IconBlock;
var IconBookmark = (0, _withSize["default"])(Bookmark);
exports.IconBookmark = IconBookmark;
var IconBrackets = (0, _withSize["default"])(Brackets);
exports.IconBrackets = IconBrackets;
var IconBuildingCircle = (0, _withSize["default"])(BuildingCircle);
exports.IconBuildingCircle = IconBuildingCircle;
var IconBuilding = (0, _withSize["default"])(Building);
exports.IconBuilding = IconBuilding;
var IconCalendarAdd = (0, _withSize["default"])(CalendarAdd);
exports.IconCalendarAdd = IconCalendarAdd;
var IconCalendarClock = (0, _withSize["default"])(CalendarClock);
exports.IconCalendarClock = IconCalendarClock;
var IconCalendar = (0, _withSize["default"])(Calendar);
exports.IconCalendar = IconCalendar;
var IconChatBubbleEmpty = (0, _withSize["default"])(ChatBubbleEmpty);
exports.IconChatBubbleEmpty = IconChatBubbleEmpty;
var IconChatBubbleLine = (0, _withSize["default"])(ChatBubbleLine);
exports.IconChatBubbleLine = IconChatBubbleLine;
var IconChatBubble = (0, _withSize["default"])(ChatBubble);
exports.IconChatBubble = IconChatBubble;
var IconChatBubbles = (0, _withSize["default"])(ChatBubbles);
exports.IconChatBubbles = IconChatBubbles;
var IconCheckCircle = (0, _withSize["default"])(CheckCircle);
exports.IconCheckCircle = IconCheckCircle;
var IconCheck = (0, _withSize["default"])(Check);
exports.IconCheck = IconCheck;
var IconCheckboxBlankReadonly = (0, _withSize["default"])(CheckboxBlankReadonly);
exports.IconCheckboxBlankReadonly = IconCheckboxBlankReadonly;
var IconChevron = (0, _withDirection["default"])((0, _withSize["default"])(Chevron));
exports.IconChevron = IconChevron;
var IconClick = (0, _withSize["default"])(Click);
exports.IconClick = IconClick;
var IconContributor = (0, _withSize["default"])(Contributor);
exports.IconContributor = IconContributor;
var IconCopy = (0, _withSize["default"])(Copy);
exports.IconCopy = IconCopy;
var IconCreditCard = (0, _withSize["default"])(CreditCard);
exports.IconCreditCard = IconCreditCard;
var IconCrown = (0, _withSize["default"])(Crown);
exports.IconCrown = IconCrown;
var IconCustomerJourney = (0, _withSize["default"])(CustomerJourney);
exports.IconCustomerJourney = IconCustomerJourney;
var IconDesktop = (0, _withSize["default"])(Desktop);
exports.IconDesktop = IconDesktop;
var IconDownloadSquareSolid = (0, _withSize["default"])(DownloadSquareSolid);
exports.IconDownloadSquareSolid = IconDownloadSquareSolid;
var IconDownloadSquare = (0, _withSize["default"])(DownloadSquare);
exports.IconDownloadSquare = IconDownloadSquare;
var IconDownload = (0, _withSize["default"])(Download);
exports.IconDownload = IconDownload;
var IconDustpan = (0, _withSize["default"])(Dustpan);
exports.IconDustpan = IconDustpan;
var IconEnvelopeLine = (0, _withSize["default"])(EnvelopeLine);
exports.IconEnvelopeLine = IconEnvelopeLine;
var IconEnvelope = (0, _withSize["default"])(Envelope);
exports.IconEnvelope = IconEnvelope;
var IconExpand = (0, _withSize["default"])(Expand);
exports.IconExpand = IconExpand;
var IconEyeSlashed = (0, _withSize["default"])(EyeSlashed);
exports.IconEyeSlashed = IconEyeSlashed;
var IconEye = (0, _withSize["default"])(Eye);
exports.IconEye = IconEye;
var IconFaceAngry = (0, _withSize["default"])(FaceAngry);
exports.IconFaceAngry = IconFaceAngry;
var IconFaceHappy = (0, _withSize["default"])(FaceHappy);
exports.IconFaceHappy = IconFaceHappy;
var IconFaceMeh = (0, _withSize["default"])(FaceMeh);
exports.IconFaceMeh = IconFaceMeh;
var IconFacebookMessenger = (0, _withSize["default"])(FacebookMessenger);
exports.IconFacebookMessenger = IconFacebookMessenger;
var IconFeedback = (0, _withSize["default"])(Feedback);
exports.IconFeedback = IconFeedback;
var IconFileAudio = (0, _withSize["default"])(FileAudio);
exports.IconFileAudio = IconFileAudio;
var IconFileBlank = (0, _withSize["default"])(FileBlank);
exports.IconFileBlank = IconFileBlank;
var IconFileCoding = (0, _withSize["default"])(FileCoding);
exports.IconFileCoding = IconFileCoding;
var IconFileCopy = (0, _withSize["default"])(FileCopy);
exports.IconFileCopy = IconFileCopy;
var IconFileCsv = (0, _withSize["default"])(FileCsv);
exports.IconFileCsv = IconFileCsv;
var IconFileDollar = (0, _withSize["default"])(FileDollar);
exports.IconFileDollar = IconFileDollar;
var IconFilePdf = (0, _withSize["default"])(FilePdf);
exports.IconFilePdf = IconFilePdf;
var IconFileText = (0, _withSize["default"])(FileText);
exports.IconFileText = IconFileText;
var IconFileVideo = (0, _withSize["default"])(FileVideo);
exports.IconFileVideo = IconFileVideo;
var IconFileZip = (0, _withSize["default"])(FileZip);
exports.IconFileZip = IconFileZip;
var IconFile = (0, _withSize["default"])(File);
exports.IconFile = IconFile;
var IconFilter = (0, _withSize["default"])(Filter);
exports.IconFilter = IconFilter;
var IconFormatting = (0, _withSize["default"])(Formatting);
exports.IconFormatting = IconFormatting;
var IconGear = (0, _withSize["default"])(Gear);
exports.IconGear = IconGear;
var IconGiftOpen = (0, _withSize["default"])(GiftOpen);
exports.IconGiftOpen = IconGiftOpen;
var IconGlobe = (0, _withSize["default"])(Globe);
exports.IconGlobe = IconGlobe;
var IconGoogleMessage = (0, _withSize["default"])(GoogleMessage);
exports.IconGoogleMessage = IconGoogleMessage;
var IconGraphBar = (0, _withSize["default"])(GraphBar);
exports.IconGraphBar = IconGraphBar;
var IconGraphPie = (0, _withSize["default"])(GraphPie);
exports.IconGraphPie = IconGraphPie;
var IconHamburger = (0, _withSize["default"])(Hamburger);
exports.IconHamburger = IconHamburger;
var IconInbox = (0, _withSize["default"])(Inbox);
exports.IconInbox = IconInbox;
var IconInfo = (0, _withSize["default"])(Info);
exports.IconInfo = IconInfo;
var IconIntercom = (0, _withSize["default"])(Intercom);
exports.IconIntercom = IconIntercom;
var IconLayout = (0, _withSize["default"])(Layout);
exports.IconLayout = IconLayout;
var IconLightBulb = (0, _withSize["default"])(LightBulb);
exports.IconLightBulb = IconLightBulb;
var IconList = (0, _withSize["default"])(List);
exports.IconList = IconList;
var IconLocationAdmin = (0, _withSize["default"])(LocationAdmin);
exports.IconLocationAdmin = IconLocationAdmin;
var IconLocationCircle = (0, _withSize["default"])(LocationCircle);
exports.IconLocationCircle = IconLocationCircle;
var IconLocationPinLine = (0, _withSize["default"])(LocationPinLine);
exports.IconLocationPinLine = IconLocationPinLine;
var IconLocationPin = (0, _withSize["default"])(LocationPin);
exports.IconLocationPin = IconLocationPin;
var IconLocationUserCircle = (0, _withSize["default"])(LocationUserCircle);
exports.IconLocationUserCircle = IconLocationUserCircle;
var IconLocationUser = (0, _withSize["default"])(LocationUser);
exports.IconLocationUser = IconLocationUser;
var IconLock = (0, _withSize["default"])(Lock);
exports.IconLock = IconLock;
var IconLogout = (0, _withSize["default"])(Logout);
exports.IconLogout = IconLogout;
var IconManager = (0, _withSize["default"])(Manager);
exports.IconManager = IconManager;
var IconMarkUnread = (0, _withSize["default"])(MarkUnread);
exports.IconMarkUnread = IconMarkUnread;
var IconMedal = (0, _withSize["default"])(Medal);
exports.IconMedal = IconMedal;
var IconMention = (0, _withSize["default"])(Mention);
exports.IconMention = IconMention;
var IconMinus = (0, _withSize["default"])(Minus);
exports.IconMinus = IconMinus;
var IconMobilePhoneCheck = (0, _withSize["default"])(MobilePhoneCheck);
exports.IconMobilePhoneCheck = IconMobilePhoneCheck;
var IconMobilePhoneClose = (0, _withSize["default"])(MobilePhoneClose);
exports.IconMobilePhoneClose = IconMobilePhoneClose;
var IconMobilePhoneQuestionMark = (0, _withSize["default"])(MobilePhoneQuestionMark);
exports.IconMobilePhoneQuestionMark = IconMobilePhoneQuestionMark;
var IconMobilePhoneView = (0, _withSize["default"])(MobilePhoneView);
exports.IconMobilePhoneView = IconMobilePhoneView;
var IconMobilePhone = (0, _withSize["default"])(MobilePhone);
exports.IconMobilePhone = IconMobilePhone;
var IconMore = (0, _withSize["default"])(More);
exports.IconMore = IconMore;
var IconNotepad = (0, _withSize["default"])(Notepad);
exports.IconNotepad = IconNotepad;
var IconOffers = (0, _withSize["default"])(Offers);
exports.IconOffers = IconOffers;
var IconOpenEnvelope = (0, _withSize["default"])(OpenEnvelope);
exports.IconOpenEnvelope = IconOpenEnvelope;
var IconPaperclip = (0, _withSize["default"])(Paperclip);
exports.IconPaperclip = IconPaperclip;
var IconPayments = (0, _withSize["default"])(Payments);
exports.IconPayments = IconPayments;
var IconPaymentsLogo = (0, _withSize["default"])(PaymentsLogo);
exports.IconPaymentsLogo = IconPaymentsLogo;
var IconPencilSmall = (0, _withSize["default"])(PencilSmall);
exports.IconPencilSmall = IconPencilSmall;
var IconPencilWrite = (0, _withSize["default"])(PencilWrite);
exports.IconPencilWrite = IconPencilWrite;
var IconPencil = (0, _withSize["default"])(Pencil);
exports.IconPencil = IconPencil;
var IconPending = (0, _withSize["default"])(Pending);
exports.IconPending = IconPending;
var IconPictureLayerSolid = (0, _withSize["default"])(PictureLayerSolid);
exports.IconPictureLayerSolid = IconPictureLayerSolid;
var IconPictureLayer = (0, _withSize["default"])(PictureLayer);
exports.IconPictureLayer = IconPictureLayer;
var IconPlay = (0, _withSize["default"])(Play);
exports.IconPlay = IconPlay;
var IconPlusCircleSolid = (0, _withSize["default"])(PlusCircleSolid);
exports.IconPlusCircleSolid = IconPlusCircleSolid;
var IconPlusCircle = (0, _withSize["default"])(PlusCircle);
exports.IconPlusCircle = IconPlusCircle;
var IconPlus = (0, _withSize["default"])(Plus);
exports.IconPlus = IconPlus;
var IconPodiumIcon = (0, _withSize["default"])(PodiumIcon);
exports.IconPodiumIcon = IconPodiumIcon;
var IconPossibleIntegrations = (0, _withSize["default"])(PossibleIntegrations);
exports.IconPossibleIntegrations = IconPossibleIntegrations;
var IconQuestionSolid = (0, _withSize["default"])(QuestionSolid);
exports.IconQuestionSolid = IconQuestionSolid;
var IconQuestion = (0, _withSize["default"])(Question);
exports.IconQuestion = IconQuestion;
var IconReceipt = (0, _withSize["default"])(Receipt);
exports.IconReceipt = IconReceipt;
var IconRefund = (0, _withSize["default"])(Refund);
exports.IconRefund = IconRefund;
var IconSalesforce = (0, _withSize["default"])(Salesforce);
exports.IconSalesforce = IconSalesforce;
var IconSearch = (0, _withSize["default"])(Search);
exports.IconSearch = IconSearch;
var IconSend = (0, _withSize["default"])(Send);
exports.IconSend = IconSend;
var IconShare = (0, _withSize["default"])(Share);
exports.IconShare = IconShare;
var IconShieldChecked = (0, _withSize["default"])(ShieldChecked);
exports.IconShieldChecked = IconShieldChecked;
var IconShieldX = (0, _withSize["default"])(ShieldX);
exports.IconShieldX = IconShieldX;
var IconSkyhookLogo = (0, _withSize["default"])(SkyhookLogo);
exports.IconSkyhookLogo = IconSkyhookLogo;
var IconStarAdd = (0, _withSize["default"])(StarAdd);
exports.IconStarAdd = IconStarAdd;
var IconStarCrossed = (0, _withSize["default"])(StarCrossed);
exports.IconStarCrossed = IconStarCrossed;
var IconStarLine = (0, _withSize["default"])(StarLine);
exports.IconStarLine = IconStarLine;
var IconStar = (0, _withSize["default"])(Star);
exports.IconStar = IconStar;
var IconStore = (0, _withSize["default"])(Store);
exports.IconStore = IconStore;
var IconTable = (0, _withSize["default"])(Table);
exports.IconTable = IconTable;
var IconTag = (0, _withSize["default"])(Tag);
exports.IconTag = IconTag;
var IconTeamchat = (0, _withSize["default"])(Teamchat);
exports.IconTeamchat = IconTeamchat;
var IconTrash = (0, _withSize["default"])(Trash);
exports.IconTrash = IconTrash;
var IconTrendingDown = (0, _withSize["default"])(TrendingDown);
exports.IconTrendingDown = IconTrendingDown;
var IconTrendingUp = (0, _withSize["default"])(TrendingUp);
exports.IconTrendingUp = IconTrendingUp;
var IconUserChat = (0, _withSize["default"])(UserChat);
exports.IconUserChat = IconUserChat;
var IconUserGroup = (0, _withSize["default"])(UserGroup);
exports.IconUserGroup = IconUserGroup;
var IconUserMagnify = (0, _withSize["default"])(UserMagnify);
exports.IconUserMagnify = IconUserMagnify;
var IconUserPlus = (0, _withSize["default"])(UserPlus);
exports.IconUserPlus = IconUserPlus;
var IconUserSolid = (0, _withSize["default"])(UserSolid);
exports.IconUserSolid = IconUserSolid;
var IconUser = (0, _withSize["default"])(User);
exports.IconUser = IconUser;
var IconVariables = (0, _withSize["default"])(Variables);
exports.IconVariables = IconVariables;
var IconVideo = (0, _withSize["default"])(Video);
exports.IconVideo = IconVideo;
var IconWand = (0, _withSize["default"])(Wand);
exports.IconWand = IconWand;
var IconWebchat = (0, _withSize["default"])(Webchat);
exports.IconWebchat = IconWebchat;
var IconWindowArrow = (0, _withSize["default"])(WindowArrow);
exports.IconWindowArrow = IconWindowArrow;
var IconWindowChecked = (0, _withSize["default"])(WindowChecked);
exports.IconWindowChecked = IconWindowChecked;
var IconXCircle = (0, _withSize["default"])(XCircle);
exports.IconXCircle = IconXCircle;
var IconX = (0, _withSize["default"])(X);
exports.IconX = IconX;